import type { CaseDetail } from './portfolio';
import chefsPrideCase from '@/mocks/cases/chefsPride';
import fujitsuRecruitCase from '@/mocks/cases/fujitsuRecruit';
import sompoHimawariCase from '@/mocks/cases/sompoHimawari';
import remoCartCase from '@/mocks/cases/remoCart';
import hitachiSolutionsCase from '@/mocks/cases/hitachiSolutions';
import hitachiSocialCase from '@/mocks/cases/hitachiSocial';
import jmilkDieteticCase from '@/mocks/cases/jmilkDietetic';
import jwwTisiCase from '@/mocks/cases/jwwTisi';
import patexCase from '@/mocks/cases/patex';
import androidRetailCase from '@/mocks/cases/androidRetail';
import kaoInfoCase from '@/mocks/cases/kaoInfo';
import plusKeshiponCase from '@/mocks/cases/plusKeshipon';
import qSaiAojiruCase from '@/mocks/cases/qSaiAojiru';
import aizuCoinCase from '@/mocks/cases/aizuCoin';
import aizuCoinDesignGuidelineCase from '@/mocks/cases/aizuCoinDesignGuideline';
import originDesignThinkingCase from '@/mocks/cases/originDesignThinking';

export const caseDetails: CaseDetail[] = [
  {
    id: 'yanjan-blue-membership',
    project: 'ヤンジャンアプリ BLUEメンバーシップ UXデザイン',
    client: '株式会社集英社',
    year: '2024',
    category: 'UX Design / App / Subscription',
    role: 'UX Design / Service Design / Behavioral Design',
    issue: 'ヤンジャンアプリのBLUEメンバーシップ（月額980円）の加入率向上。既存読者が「いいかも！」と思える体験設計が課題。',
    challenge: '「待てばゼロ円」読者をサブスク入会へ導くための動機形成。既存読者層と新規層、それぞれに対応するアプローチの違いを設計すること。',
    insight: 'マンガは「自由に使える時間や待ち時間を、有意義なものに変えてくれる手のひらのエンターテインメント」。サブスク加入者の52%が毎週5回以上利用するヘビーユーザー。「続きが気になる」「面白かった」という感情の高まりを、次の閲覧行動へつなげることで、継続利用の動機をつくる。',
    strategy: 'デザインコンセプトは「BLUEメンバーシップ、いいかも！」と思える体験。単純接触効果（ザイオンス効果）を活用し、面白いマンガとの「出会いやすさ」をデザインする。履歴共有「友達の家の本棚」体験、読者の感情を可視化する「昂ったページにいいね」機能、心理学に基づくUI改善を三柱に。',
    experience: '履歴共有機能で履歴を公開できるBLUEメンバー間の「本棚」体験。読んだ後に昂ったページに「いいね」できる機能で、翌週の盛り上がりシーンがアプリ上で分かる。読者の感情を見える化することで、「みんな、どこで盛り上がったかな？」という共感を生む。',
    output: 'UXデザイン考え方・アイデア共有資料、体験アイデア：友達の家の本棚・昂ったページにいいね、UI認知心理学の実践提案。',
    impact: '読者の感情を起点にサブスクフローを設計。作家・編集者目線でのデータ活用という新しい価値も認められたアイデア。',
    images: [
      {
        src: '/assets/migrated/f1682af4ad4f8f2322c1.webp',
        caption: 'デザインコンセプト — BLUEメンバーシップへ導くUX',
      },
      {
        src: '/assets/migrated/d8498a0e72f889b8ed66.webp',
        caption: 'BLUEメンバーシップへ導くUXデザイン',
      },
      {
        src: '/assets/migrated/175fabb88cdb4d16d763.webp',
        caption: 'ターゲットごとのアプローチの違い',
      },
      {
        src: '/assets/migrated/f116062595857bc1864e.webp',
        caption: 'ヤングジャンプ読者の属性',
      },
      {
        src: '/assets/migrated/5b6ee0b589197f584d5a.webp',
        caption: 'サブスクに対する意識調査',
      },
      {
        src: '/assets/migrated/5091261f23227abb32a3.webp',
        caption: '体験アイデア：友達の家の本棚',
      },
      {
        src: '/assets/migrated/bd41861f82f442e38caa.webp',
        caption: '5A Customer JourneyとUX',
      },
      {
        src: '/assets/migrated/7f96bae380ca466525f2.webp',
        caption: '体験アイデア：気持ちが昂った「ページ」にいいね',
      },
      {
        src: '/assets/migrated/a131617f0fb63bc4cd09.webp',
        caption: '「読者がどこに感情を動かされたかが分かる、ヤンジャン」',
      },
      {
        src: '/assets/migrated/56e90c82a4e928c2c0db.webp',
        caption: 'UIデザインによる体験向上 — 面白いマンガとの出会いやすさ',
      },
      {
        src: '/assets/migrated/6f40801d21815d46feaa.webp',
        caption: 'デザインアプローチとアイデア — セレンディピティを呼び込む「3つのA」',
      },
      {
        src: '/assets/migrated/ac456554ed6cfbb1bbb1.webp',
        caption: 'まとめ — ターゲット別体験設計からBLUEメンバーシップ加入へ',
      },
    ],
  },
  {
    id: 'sheaful-wellbeing',
    project: 'シアフル Well-being アプリ UX/UI リデザイン',
    client: '住友生命保険相互会社',
    year: '2025',
    category: 'UX/UI / Behavioral Design / Well-being',
    role: 'UX Design / Behavioral Design / Service Design / UI Design',
    issue: 'シアフルアプリの継続使用率が伸び悩み。診断体験後の日常利用が弱く、Well-being as a Serviceの入口施策としての継続的会員基盤が構築できていない。',
    challenge: '診断までは興味を持つが、診断後の体験が期待を超えない状態。「占い的な楽しさ」に対して「次の行動」が弱く、体験価値が途切れてしまっている。',
    insight: '「気分が少し落ち込んだ時」なつかしさを感じやすく、過去を思い出すことで社会的つながり感が高まる。自己決定理論（自律性・有能感・関係性）を軸に、ユーザーが自発的に続けたくなる体験を設計する。',
    strategy: '「習慣化のデザイン」をコンセプトに、診断後の「推奨→行動→記録」のサイクルを回す主要画面を再設計。ビヘイビアデザイン（B=MAP理論・Hookモデル）を活用し、単なるUI改善を超えた行動変容設計を提案。',
    experience: 'リデザインしたコアサイクル（6画面）で推奨→行動→記録の一巡を体験。ペルソナが少し落ち込んだ時に最適なアクションを提案する「やってみたくなる推奨」。「簡単×楽しい」行動設計で、繰り返したくなる体験をつくる。',
    output: 'ビジョン再整理（PPP図）、アーキタイプペルソナ、モチベーションループ、コアサイクル、コンセプトシート、スタイリングされた主要画面（6画面）、ペイオフマトリクス。',
    impact: '継続使用率向上に向けた体験の核（コアサイクル）を再構築。行動変容設計の観点から、引き続き会社対話の展開へ。',
    images: [
      {
        src: '/assets/migrated/7bfe17f07ba204cfa70c.webp',
        caption: 'TISI側の理解 — シアフルの役割と課題の整理',
      },
      {
        src: '/assets/migrated/115376171bf0636c6fcd.webp',
        caption: '提案コンセプト — 習慣化のデザイン',
      },
      {
        src: '/assets/migrated/2a4ea4e3f6d8d32a6558.webp',
        caption: 'デザインアプローチ — 現状の体験上の課題',
      },
      {
        src: '/assets/migrated/019a0fb61e752860c8f7.webp',
        caption: 'ビヘイビアデザイン — 自己決定理論の活用',
      },
      {
        src: '/assets/migrated/6b3b072d7c3f0776643f.webp',
        caption: '「やってみたくなる推奨」— UXアイデアイメージ',
      },
      {
        src: '/assets/migrated/86240d7bcd11fab9207a.webp',
        caption: 'コアサイクル — 推奨→行動→記録の1巡',
      },
      {
        src: '/assets/migrated/8830dcaee3bd983f51bf.webp',
        caption: 'ストーリーボード — ユーザーテスト用受容性評価',
      },
      {
        src: '/assets/migrated/b99127641260a933a68f.webp',
        caption: 'スタイリングされた主要画面 — ビジュアルデザイン更新',
      },
      {
        src: '/assets/migrated/18b1c48da75531af6657.webp',
        caption: 'デザイン資料 — ページ9',
      },
      {
        src: '/assets/migrated/84dd2ea384d15ed5a3ca.webp',
        caption: 'デザイン資料 — ページ10',
      },
      {
        src: '/assets/migrated/234a271a94debef38731.webp',
        caption: 'デザインアプローチ — プロジェクト全体のフロー設計',
      },
      {
        src: '/assets/migrated/1e524376164adddaeeeb.webp',
        caption: 'アウトプットイメージ — ビジョン再整理とPPP図',
      },
      {
        src: '/assets/migrated/d4d704da418dd6c52241.webp',
        caption: 'アウトプットイメージ — モチベーションループ設計',
      },
      {
        src: '/assets/migrated/0a0ecdd3407e8715b05b.webp',
        caption: 'アウトプットイメージ — コアサイクルと体験フロー定義',
      },
      {
        src: '/assets/migrated/fd441da528bd22997836.webp',
        caption: 'アウトプットイメージ — ユーザーテスト用ストーリーボード',
      },
      {
        src: '/assets/migrated/86d5da67e9044e3e0c7a.webp',
        caption: 'アウトプットイメージ — スタイリングされた主要画面',
      },
    ],
  },
  aizuCoinCase,
  aizuCoinDesignGuidelineCase,
  {
    id: 'baby-me-belk',
    project: 'BABY&Me BELK.',
    client: 'BABY&Me / ascon',
    year: '2019–2022',
    category: 'Brand Development',
    role: 'Brand Strategy / Naming / Creative Direction / Web / Event',
    issue: 'ヒップシートキャリア市場での差別化と、新しいブランドとしての明確な意味づけが必要だった。',
    challenge: '既存のベビーキャリア市場は機能訴求が中心で、ブランドとしての感情価値が薄かった。',
    insight: '「抱っこ」は移動の手段ではなく、親子のコミュニケーションそのもの。ヒップシートは登山のリュックから発想を得た商品であり、育児は誰しもが初体験となる「山登り」のようなゴールの見えない試練。',
    strategy: 'BELK.はドイツ語Berg（=山）が語源の読みやすい造語。「親子の絆を支える道具」というブランドポジションを確立。製品名、VI、世界観を一貫して設計。「その負担を少しでも軽減し、最高峰の登山を、子供と共に家族の皆んなで成し得てほしい」というコミュニケーションコンセプトで展開。',
    experience: 'ウェブ、パッケージ、イベント、店頭ディスプレイまで統一した体験を構築。',
    output: 'Brand Concept / Naming BELK. / Logo / VI / Web / Package / Event / Photography Direction',
    impact: '新ブランドとして市場投入。認知獲得と販売チャネル拡大を実現。GOOD DESIGN AWARD 2021、KIDS DESIGN AWARD 2021 受賞。',
    images: [
      { src: '/assets/migrated/1501855bfbdefb599b13.png', caption: 'Hero Visual — Brand Overview' },
      { src: '/assets/migrated/0f65ae86b0328d667163.png', caption: 'Brand Identity / VI System' },
      { src: '/assets/migrated/02643038e30a1a67b21f.png', caption: 'Logo / Naming Design' },
      { src: '/assets/migrated/f4d54aa144bae103a185.png', caption: 'Web / Digital Design' },
      { src: '/assets/migrated/453a167f84867d4b4df8.png', caption: 'Product / Package' },
      { src: '/assets/migrated/1222620c2b656bd18582.png', caption: 'Retail / Store Communication' },
      { src: '/assets/migrated/1536d1983dfc9f77468d.png', caption: 'Event / Brand Experience' },
      { src: '/assets/migrated/fe23e237a6e22f0f0104.png', caption: 'Photography Direction' },
      { src: '/assets/migrated/d7595fe5dff15c970682.png', caption: 'Lifestyle / Scene' },
      { src: '/assets/migrated/bab820abe57d43546c99.png', caption: 'Brand Application' },
      {
        src: '/assets/migrated/b66cc0aba4ed364378f0.webp',
        caption: 'BELK. Brand Visual — Hero Image',
        large: true,
      },
    ],
  },
  {
    id: 'yokozemachi',
    project: 'YOKOZEMACHI Green Festival Gate',
    client: '横瀬町 / TISI Inc.',
    year: '2025',
    category: 'Regional Brand / GI / Experience / Spatial',
    role: 'Brand Strategy / Naming / VI / Experience / Spatial / Creative Direction',
    issue: '地域資産（グリーンインフラ・Green Festival Gate・森側 MORIGAWA）が点在し、それぞれの価値が一つの体験として認識されにくい状況を、ブランディングの視点から再構成。',
    challenge: '環境価値を抽象的に伝えるのではなく、地域・現場・楽しさのストーリーとして届けること。観光・移住・地域資源を一つのストーリーとして統合する必要があった。',
    insight: '「森のインターフェース」という比喩で、環境と人をつなぐ装置としてブランドを捉え直す。「横瀬」の地名が持つ「山と人が出会う場所」の意味を現代の体験デザインとして蘇らせる。',
    strategy: 'ブランド名「YOKOZEMACHI」を命名。地域資源を「Green Festival Gate」という体験コンセプトで統合。ICONICブランディング戦略で、グリーンインフラを「森のインターフェース」と定義。Wellness・Creation・Activation・Sustainability・Open Gateの5ゾーニングでランドスケープデザインを展開。',
    experience: '入口から祭りの会場、散策ルート、飲食、買い物まで一つの体験として設計。ブランド体験、サイン、ウェブ、イベントを通じて、環境と人の接点をデザイン。「さあ、ゲートをくぐろう！」というコミュニケーションで来場意欲を喚起。',
    output: 'Naming / Logo / VI / Sign / Spatial Design / Event Design / Communication / Zoning Plan / ICONIC Branding Strategy',
    impact: '地域ブランドの確立と認知向上。観光・移住・地域活性化の接点創出。グリーンインフラへの理解と関与の拡大。',
    images: [
      { src: '/assets/migrated/d00b4f9f53e40dd93cd1.png', caption: 'Hero Visual — YOKOZEMACHI Brand Overview' },
      { src: '/assets/migrated/6d4e64a44014b89e6a1f.png', caption: 'Brand Identity / Logo / VI' },
      { src: '/assets/migrated/d8c7ecf50b3391bb025b.png', caption: 'Sign / Spatial Design' },
      { src: '/assets/migrated/c9677f7d640f7cca92df.png', caption: 'Experience Design / Festival Gate' },
      { src: '/assets/migrated/9d37daffcc093e43f6d8.png', caption: 'Communication Design' },
      { src: '/assets/migrated/1b9ca8be2cb5a9c0c952.png', caption: 'Visual Identity System' },
      { src: '/assets/migrated/557967e20823ccea9787.png', caption: 'Retail / Promotional Materials' },
      { src: '/assets/migrated/0757d3645171d8afba3c.png', caption: 'Regional Brand Story' },
      { src: '/assets/migrated/d71abde4ab6fe41c0533.png', caption: 'Brand Application / Touchpoint' },
      { src: '/assets/migrated/bf7ddedc4f75e47e0362.webp', caption: '中心地のランドスケープデザイン（ベンチマーク）— Comoris Urban Share Forest。都会の人に森との接点をつくるアーバンシェアフォレストキット' },
      { src: '/assets/migrated/8586afc95e15afc831b4.webp', caption: 'ICONIC Branding / Design PLAN — YOKOZEMACHI GREEN FESTIVAL GATE ブランディング・空間デザイン' },
      { src: '/assets/migrated/eedef292490f74dca6ab.webp', caption: '「GREEN RELATION」に掛け合わせる横瀬町の既存アセット候補 — 自然・公共・民間・観光の4分類で整理' },
      { src: '/assets/migrated/ff098b7218add5b5efce.webp', caption: '森のinterface — スマートフォンのアプリのように触って・試して・調べて・学んで・工夫して。みんなで森を活かし守るキッカケをつくる' },
      { src: '/assets/migrated/c7894e905e8cd4cc6a9d.webp', caption: '中心地のグリーンインフラとしての機能的役割 — 「森のinterface」としての中心地から達成する目的の明確化と町内のアセットを活かした手段の検討' },
      { src: '/assets/migrated/cc69755da05378d56c65.webp', caption: 'ICONIC Branding / Design PLAN — YOKOZEMACHI GREEN FESTIVAL GATE ロゴタイプ・グリッド構成デザイン' },
      { src: '/assets/migrated/7e4020fdb2957a0f65b4.webp', caption: 'Our Goal — 地域内外の人びとが周辺の自然に関心を持ち、関わり活用することで自然という宝物を護りながら地域から新しい価値を共創し続ける' },
      { src: '/assets/migrated/03f6f35bd125f706be98.webp', caption: 'ICONIC Branding / Design PLAN — 駅広告・プロモーション展開（JR池袋駅・西武池袋駅・屋外広告）' },
      { src: '/assets/migrated/28cfdbeabe4640d4b6e0.webp', caption: 'Land scape Design / ゾーニング PLAN — Wellness・Creation・Activation・Open Gate・Sustainability の5ゾーン構成' },
      { src: '/assets/migrated/56403f2effebba244615.webp', caption: 'YOKOZEMACHI GREEN FESTIVAL GATE 入口 — 「さあ、ゲートをくぐろう！」実写写真' },
    ],
  },
  {
    id: 'regional-currency-20',
    project: 'LVP 2.0 ブランド戦略',
    client: 'Regional Community Platform Initiative',
    year: '2024',
    category: 'Brand Strategy / Communication Design',
    role: 'Business Design / CX Planning / Brand Strategy / Platform Design',
    issue: '地域コミュニティプラットフォームとしての価値が市民に伝わらず、行政・事業者・市民の連携が十分に活かされていなかった。',
    challenge: '多様なステークホルダーの利害を調和し、ひとつのプラットフォームとして体験を設計する複雑さ。',
    insight: 'プラットフォームの価値は「使える機能」ではなく「誰とつながれるか」にある。参加の動機を社会性に置く。',
    strategy: '次世代の地域参加プラットフォームとして再構築。市民・行政・事業者をつなぐコミュニティ基盤として構想。',
    experience: '市民・事業者・行政が共通して体験できる、デジタルとリアルのハイブリッドな顧客体験を設計。',
    output: 'プラットフォームコンセプト、体験設計、ブランド、ステークホルダーコミュニケーション。',
    impact: '地域内の参加拡大とコミュニティ活性化。行政・事業者との協働基盤の確立。',
    images: [
      {
        src: '/assets/migrated/8603822872f3af48e471.webp',
        caption: 'LVP 2.0 表紙 — LOCAL VALUE PLATFORM / 地域をつなぎ、動かすブランド戦略',
      },
      {
        src: '/assets/migrated/6ec2f58cdb4d580b42aa.webp',
        caption: '企画書表紙 — デジタル地域通貨2.0事業 新ブランド戦略PLAN / コミュニケーション設計ロードマップ',
      },
      {
        src: '/assets/migrated/33403e45a04cc911501f.webp',
        caption: 'INDEX（現状）— 12章構成の目次',
      },
      {
        src: '/assets/migrated/199efcd76c3ca115e747.webp',
        caption: 'CHAPTER 01 — なぜ今、地域経営の仕組みを変える必要があるのか',
      },
      {
        src: '/assets/migrated/8605f6d5ca7d6706e351.webp',
        caption: 'PAGE 01 — 日本の地域が直面する最大の構造変化 — 人口減少',
      },
      {
        src: '/assets/migrated/5a11b331e146a261233c.webp',
        caption: 'PAGE 01 — 本事業が解決する社会課題から',
      },
      {
        src: '/assets/migrated/c085fe9dbeaac9132642.webp',
        caption: 'PAGE 02 — 地域の個別課題は、ひとつの「負の循環」でつながっている',
      },
      {
        src: '/assets/migrated/40d306ae4648aed37883.webp',
        caption: 'PAGE 04 — 自治体・金融機関・企業・住民は、同じ構造問題の異なる表れである',
      },
      {
        src: '/assets/migrated/4749882d879babd6bbcd.webp',
        caption: 'PAGE 03 — 人口減少だけではない。「地域のお金が地域に残らない」という問題',
      },
      {
        src: '/assets/migrated/9152da28ad97f0d1d1c8.webp',
        caption: 'PAGE 03 — 地域のお金が地域に残らない問題の構造と解決方向性',
      },
      {
        src: '/assets/migrated/43584ead67d24fe73268.webp',
        caption: 'PAGE 05 — CHAPTER 01 結論 | 個別最適から、地域全体の仕組みの再設計へ',
      },
      {
        src: '/assets/migrated/5e2181b3934bebabc19d.webp',
        caption: 'STRATEGY VISION | 個別の施策をつなぎ、地域全体が「循環・改善し続ける」地域経営へ',
      },
      {
        src: '/assets/migrated/c70d0f28f74d31c6d7a8.webp',
        caption: 'CHAPTER 02 | なぜ、これまでの地方創生では地域を変えられなかったのか',
      },
      {
        src: '/assets/migrated/06e0f3e033c2410e74a2.webp',
        caption: 'PAGE 01 | 地方創生では、これまで多くの施策が行われてきた',
      },
      {
        src: '/assets/migrated/74e3fc9a2ca9c93d6e5a.webp',
        caption: 'PAGE 02 | 個別施策は成果を生んでも、地域全体の構造変化につながりにくい',
      },
      {
        src: '/assets/migrated/103124049924dbe5646f.webp',
        caption: 'PAGE 03 | 「単発・短期」で終わると、地域に資産が蓄積されにくい',
      },
      {
        src: '/assets/migrated/21fa9069cfc3cafc9930.webp',
        caption: 'PAGE 04 | 主体ごとの個別最適では、地域全体を動かしにくい',
      },
      {
        src: '/assets/migrated/c7817633f4d03082e6a4.webp',
        caption: 'PAGE 05 — CHAPTER 02 結論 | 必要なのは「新しい施策」ではなく、「施策・主体・データがつながる共通基盤」である',
      },
      {
        src: '/assets/migrated/97b4d6a8ed4a4660706b.webp',
        caption: 'CHAPTER 01 + CHAPTER 02 まとめ | なぜ今地域経営の仕組みを変える必要があるのか、なぜこれまでの地方創生では地域を変えられなかったのか',
      },
      {
        src: '/assets/migrated/85cb48e0d08765ce0c66.webp',
        caption: 'CHAPTER 03 | なぜ、地域通貨1.0では足りないのか',
      },
      {
        src: '/assets/migrated/bc1fc616a55719432f2c.webp',
        caption: 'CHAPTER 03 PAGE 01 | 地域通貨は、地域内で「お金を循環させる仕組み」として発展してきた',
      },
      {
        src: '/assets/migrated/7cfec5e9576c7abe017f.webp',
        caption: 'CHAPTER 03 PAGE 02 | 地域通貨1.0は、「決済・ポイント・消費喚起」を中心に価値を生んできた',
      },
      {
        src: '/assets/migrated/6d7974e6f68511ee9926.webp',
        caption: 'CHAPTER 03 PAGE 03 | しかし、「お金を回す」だけでは地域の構造課題すべてには届かない',
      },
      {
        src: '/assets/migrated/3fff23efe83a99920dc9.webp',
        caption: 'CHAPTER 03 PAGE 04 | 地域通貨1.0と、これから必要な地域基盤との間には「役割のギャップ」がある',
      },
      {
        src: '/assets/migrated/d46ca914f4979afd51a8.webp',
        caption: 'CHAPTER 03 PAGE 05 — 結論 | 地域通貨を「決済手段」から「地域経営の共通基盤」へ',
      },
      {
        src: '/assets/migrated/e6a7780fd80ef118bfe2.webp',
        caption: 'CHAPTER 04 | 地域通貨2.0とは何か',
      },
      {
        src: '/assets/migrated/60b9c9ce63cb929b9471.webp',
        caption: 'CHAPTER 04 PAGE 01 | 地域通貨2.0とは、「地域経営を支える共通基盤」である',
      },
      {
        src: '/assets/migrated/015b642b85a57d042f6d.webp',
        caption: 'CHAPTER 04 PAGE 02 | 地域通貨2.0は、自治体・地方銀行・地域企業・住民をつなぐ',
      },
      {
        src: '/assets/migrated/0f28e22cc12a1eb9f775.webp',
        caption: 'CHAPTER 04 PAGE 03 | 地域通貨2.0は、地域の「4つの要素」を循環させる',
      },
      {
        src: '/assets/migrated/f269703df814bbc2437e.webp',
        caption: 'CHAPTER 04 PAGE 04 | 地域通貨2.0を構成する4つの価値軸',
      },
      {
        src: '/assets/migrated/cdda82b7cf318881cd60.webp',
        caption: 'CHAPTER 04 PAGE 05 — 定義シート | 地域通貨2.0 — WHO・VALUE・DIFFERENCE',
      },
      {
        src: '/assets/migrated/6572aa474719781c0b31.webp',
        caption: 'CHAPTER 05 | 地域通貨2.0は、地域にどのような変化を生み出すのか',
      },
      {
        src: '/assets/migrated/0256f3ce869f89a35a4d.webp',
        caption: 'CHAPTER 05 PAGE 01 | 地域通貨2.0が変えるのは「決済」ではなく「地域のつながり方」である',
      },
      {
        src: '/assets/migrated/cfdad0b3224848ccc17c.webp',
        caption: 'CHAPTER 05 PAGE 02 | 地域のお金が、「使われる」から「地域内で循環する」へ',
      },
      {
        src: '/assets/migrated/d08655407a096ed9cfdb.webp',
        caption: 'CHAPTER 05 PAGE 03 | 行政施策が、「実施する」から「届けて、測って、改善する」へ',
      },
      {
        src: '/assets/migrated/19856f05b707455c9876.webp',
        caption: 'CHAPTER 05 PAGE 04 | 地域の主体が、「別々に動く」から「共通の情報でつながる」へ',
      },
      {
        src: '/assets/migrated/5cd3eeecb3e69967495e.webp',
        caption: 'CHAPTER 05 PAGE 05 — 結論 | 地域通貨2.0が生み出す、7つの変化',
      },
      {
        src: '/assets/migrated/11f3c968b5e33079f615.webp',
        caption: 'CHAPTER 06 | 自治体に、どのような価値をもたらすのか',
      },
      {
        src: '/assets/migrated/7e673025c254a10d310f.webp',
        caption: 'CHAPTER 06 PAGE 01 | 自治体の課題は「施策がない」ことではなく「施策が地域経営としてつながりにくい」ことにある',
      },
      {
        src: '/assets/migrated/ae9a8e64d8e53e7f8006.webp',
        caption: 'CHAPTER 06 PAGE 02 | 地域通貨2.0は、自治体と住民・地域企業をつなぐ「継続的な接点」になる',
      },
      {
        src: '/assets/migrated/e26e677e0e94bbec5f7e.webp',
        caption: 'CHAPTER 06 PAGE 03 | 自治体の施策が、「実施したか」から「届いたか・使われたか」へ',
      },
      {
        src: '/assets/migrated/aef4e47524c2061b818c.webp',
        caption: 'CHAPTER 06 PAGE 04 | 施策ごとのデータを、「地域経営の改善」へつなげる',
      },
      {
        src: '/assets/migrated/7af8b26f23e5340c9302.webp',
        caption: 'CHAPTER 06 PAGE 05 — 結論 | 自治体にとっての地域通貨2.0・5つの価値',
      },
      {
        src: '/assets/migrated/edd23268e41c81e3737e.webp',
        caption: 'CHAPTER 07 | 地方銀行に、どのような価値をもたらすのか',
      },
      {
        src: '/assets/migrated/8c1ad7567a3925ff6cea.webp',
        caption: 'CHAPTER 07 PAGE 01 | 地方銀行の課題は、「企業との接点がない」ことではなく、これからは「日常的な地域活動との接点をどう広げるか」にある',
      },
      {
        src: '/assets/migrated/df2cabce058986f185c4.webp',
        caption: 'CHAPTER 07 PAGE 02 | 地域通貨2.0は、地方銀行と地域企業の「新しい継続接点」になる',
      },
      {
        src: '/assets/migrated/1a24e29251a58a686ec2.webp',
        caption: 'CHAPTER 07 PAGE 03 | 地域企業の「結果」だけでなく、地域での「活動」を支援材料へ',
      },
      {
        src: '/assets/migrated/6acce6ea91a5f58ac688.webp',
        caption: 'CHAPTER 07 PAGE 04 | 金融支援を基盤に、「地域企業支援・地域経営への関与」へ広げる',
      },
      {
        src: '/assets/migrated/6bf4f3a9b7c72f7f448d.webp',
        caption: 'CHAPTER 07 PAGE 05 — 結論 | 地方銀行にとっての地域通貨2.0・5つの価値',
      },
      {
        src: '/assets/migrated/89793f3f69499243dbcf.webp',
        caption: 'CHAPTER 08 | 地域企業・住民に、どのような価値をもたらすのか',
      },
      {
        src: '/assets/migrated/af49886ac1b1d9ae1e72.webp',
        caption: 'CHAPTER 08 PAGE 01 | 地域企業・住民にとって、地域との接点は「点」になりやすい',
      },
      {
        src: '/assets/migrated/20e9641adfdb6e4411f3.webp',
        caption: 'CHAPTER 08 PAGE 02 | 地域通貨2.0は、日常の「利用」を地域との「継続接点」に変える',
      },
      {
        src: '/assets/migrated/28275e9d556ff46f216e.webp',
        caption: 'CHAPTER 08 PAGE 03 | 地域企業にとってのVALUE | 「売る」だけでなく、地域との関係を育てる接点へ',
      },
      {
        src: '/assets/migrated/3cab91f2efea2c09c76d.webp',
        caption: 'CHAPTER 08 PAGE 04 | 住民にとってのVALUE | 「支払う」だけでなく、暮らしと地域がつながる接点へ',
      },
      {
        src: '/assets/migrated/fd89ec2a037bdf78359c.webp',
        caption: 'CHAPTER 08 PAGE 05 — 結論 | 地域企業・住民にとっての地域通貨2.0・5つのVALUE',
      },
      {
        src: '/assets/migrated/5bb492e22b504614c215.webp',
        caption: 'CHAPTER 09 | 地域全体に、どのような好循環が生まれるのか',
      },
      {
        src: '/assets/migrated/c15b4acc276e69c1b4d7.webp',
        caption: 'CHAPTER 09 PAGE 01 | 4主体のVALUEは、個別に存在するだけでは「地域全体の価値」にならない',
      },
      {
        src: '/assets/migrated/17f4df158eb4a7ae177f.webp',
        caption: 'CHAPTER 09 PAGE 02 | 地域通貨2.0が、4主体のVALUEをひとつの循環へつなぐ',
      },
      {
        src: '/assets/migrated/b44bdae23c1d554b4884.webp',
        caption: 'CHAPTER 09 PAGE 03 | 地域通貨2.0が生み出す「5つの循環」',
      },
      {
        src: '/assets/migrated/dd6e6cf161a6a583bb8a.webp',
        caption: 'CHAPTER 09 PAGE 04 | 循環から生まれるデータを、次の地域経営へ活かす',
      },
      {
        src: '/assets/migrated/f20b4ca5202407d3e61b.webp',
        caption: 'CHAPTER 09 PAGE 05 — 結論 | 地域通貨2.0が目指す、地域全体の好循環',
      },
      {
        src: '/assets/migrated/d413a0dff9be72388911.webp',
        caption: 'LVP 2.0 中扉 — 戦略を、あらゆるコンテンツへ。つながる。ひろがる。未来が動き出す。LVP 2.0 がつくる、地域の未来。',
      },
      {
        src: '/assets/migrated/e72325124e4b004e8a02.webp',
        caption: 'CHAPTER 10 | 地域通貨2.0だから実現できることは何か',
      },
      {
        src: '/assets/migrated/e0e57f521182a381c29a.webp',
        caption: 'PAGE 01 | 複数の地域施策を、「ひとつの地域接点」から届ける',
      },
      {
        src: '/assets/migrated/260847fb6b2484c15856.webp',
        caption: 'PAGE 02 | 日常の「利用」を、地域への「参加」へつなげる',
      },
      {
        src: '/assets/migrated/53353f609a6d9f40c107.webp',
        caption: 'PAGE 03 | 4主体の役割を、「地域課題」を起点につなぐ',
      },
      {
        src: '/assets/migrated/3c96b7188cda03141d42.webp',
        caption: 'PAGE 04 | 施策を「単発」で終わらせず、次の施策へつなげる',
      },
      {
        src: '/assets/migrated/d777def238dacb29978e.webp',
        caption: 'CHAPTER 10 PAGE 05 — 結論 | 地域通貨2.0だから実現できる「5つのこと」',
      },
      {
        src: '/assets/migrated/e46a0894a7c7929f4c9c.webp',
        caption: '「ワークショップから最終コンテンツへの展開」— 各章の構成と展開先',
      },
      {
        src: '/assets/migrated/28c166ba3ca03e1a080f.webp',
        caption: '最終的に完成させる ブランド戦略・コミュニケーション設計の【12ベース】',
      },
      {
        src: '/assets/migrated/1fa1a2b55f1dbd4a9486.webp',
        caption: '裏表紙 | 戦略バイブルから、あらゆるコンテンツへ。STRATEGY BIBLE — LVP 2.0 BRAND STRATEGY / COMMUNICATION DESIGN',
      },
    ],
  },
  {
    id: 'amino-index',
    project: 'amino index',
    client: 'Health Screening Service',
    year: '2021',
    category: 'Brand Strategy / Communication',
    role: 'Brand Strategy / CX & Communication Planning / Copy / Logo / Web',
    issue: '検査サービスとしての理解だけでなく、継続的な健康行動へつながるブランド価値の拡張が必要だった。',
    challenge: '検査結果の数値だけで終わるのではなく、生活者を継続的な健康行動へ導く体験を設計すること。',
    insight: '「知る」こと自体が目的ではなく、その先の「行動の変化」こそが価値。数値を自己理解のツールにする。',
    strategy: 'ブランドを「健康を指数化する」から「健康への向き合い方を変える」体験へ再定義。',
    experience: '検査体験、結果の見せ方、継続的なコミュニケーションまでを一つの体験として設計。',
    output: 'ブランド戦略、コピー、ロゴ、VI、ウェブ、コミュニケーションプラン。',
    impact: 'サービス理解の深化と、継続利用への導線を確立。',
    images: [
      { src: '/assets/migrated/5ff6db494b3d73e80807.png', caption: 'Hero Visual — amino index Brand Overview' },
      { src: '/assets/migrated/6dae7ffbdc96c075e194.png', caption: 'Brand Identity / Logo / VI' },
      { src: '/assets/migrated/501bf8804d514d00ec69.png', caption: 'Communication Strategy' },
      { src: '/assets/migrated/ef26bd210f7407aaba44.png', caption: 'Web Design / UX' },
      { src: '/assets/migrated/ef0f876b333aca72c331.png', caption: 'Digital / App Interface' },
      { src: '/assets/migrated/527cf670948adab7b981.png', caption: 'Report / Result Design' },
      { src: '/assets/migrated/084a5d7b7bdc0ab9835c.png', caption: 'Lifestyle / Health Story' },
      { src: '/assets/migrated/3a77a6e58230cab032f9.png', caption: 'Print / Communication Design' },
      { src: '/assets/migrated/aea14628bc44158d2632.png', caption: 'Service Design Detail' },
      { src: '/assets/migrated/c0f89cc2fbd2518ed901.png', caption: 'Final Output / Implementation' },
      {
        src: '/assets/migrated/841d9fdcda54353192d0.webp',
        caption: 'アミノインデックス ロゴマーク — amino!ndex アミノインデックス',
      },
      {
        src: '/assets/migrated/edfbcfee10fb4ada4fe4.webp',
        caption: 'ブランドコピーとコンセプト — 人生100年時代の健康経営をサポートするアミノインデックス',
      },
      {
        src: '/assets/migrated/61aaebe12da4bfed1a49.webp',
        caption: 'ロゴタイプの選定 — 英語書体・日本語書体の比較表',
      },
      {
        src: '/assets/migrated/c6ba9a717e68758754e0.webp',
        caption: 'ロゴレギュレーション案 A案/B案/C案 — 4ページのロゴデザイン案',
      },
      {
        src: '/assets/migrated/ee7a32b3a7320829e5bf.webp',
        caption: 'ポジショニング — 統合的な食と健康のソリューションサービス',
      },
      {
        src: '/assets/migrated/de01765802932f75f494.webp',
        caption: 'ブランディング戦略の方向性 — 未病ケアに対しウォーミングアップのひとつ。スポーツのように捉えること。+ SWOT分析',
      },
      {
        src: '/assets/migrated/a842e3ece81bb495ddc5.webp',
        caption: 'ロゴレギュレーション案 A案 — 9角形をベースに構成したオリジナルサンセリフ体',
      },
      {
        src: '/assets/migrated/102909befc1657d20148.webp',
        caption: '組み合わせ案B — futuraベースのロゴデザイン案',
      },
      {
        src: '/assets/migrated/f9cb67a9753db73fea80.webp',
        caption: '他社・健康サポート・ヘルスケアの取り組み + ヘルスケア市場の拡大傾向',
      },
      {
        src: '/assets/migrated/919cd2e13c8749bd9d76.webp',
        caption: 'アミノインデックスのサービスのこれからをみる — B to B to C から + B to C へ、生活改善ソリューションサービスへ',
      },
      {
        src: '/assets/migrated/878fe0455cfa05971517.webp',
        caption: 'その他 ロゴシンボルレギュレーション案 — a+i+human / a+i+heart / a+i+move / a+i+tours',
      },
      {
        src: '/assets/migrated/2ac6ef7e042a80e4ea07.webp',
        caption: '各種ツール展開イメージ / PR動画 / モーショングラフィック',
      },
      {
        src: '/assets/migrated/527628adf587eb357b99.webp',
        caption: 'アジパンダとの組み合わせ — Webページ / ロゴレギュレーション',
      },
      {
        src: '/assets/migrated/574f369fdb58721b586f.webp',
        caption: '組み合わせ案A — 学参欧文 ローマ字2 / オリジナルサンセリフ体',
      },
      {
        src: '/assets/migrated/9fadd94c02952195fc1c.webp',
        caption: 'まとめ — 採血結果から予防の機会創出、健康寿命の延伸に貢献するサービス',
      },
      {
        src: '/assets/migrated/58d98a62a42684a3f79a.webp',
        caption: '消費者動向マインド分析 — 健康関連サービスにおける消費者動向',
      },
      {
        src: '/assets/migrated/e892ed8a535796fc4a7a.webp',
        caption: 'ロゴシンボル案B — a + ! + solution / フィボナッチ整数・9角形モチーフ',
      },
      {
        src: '/assets/migrated/5f2b8425b10bcab6c742.webp',
        caption: 'amino !ndex ロゴマーク（赤）',
      },
      {
        src: '/assets/migrated/ca32c1eae94b5b8d3ac9.webp',
        caption: '各種ツール展開イメージ — 名刺・レター・タブレット・スマホ',
      },
      {
        src: '/assets/migrated/3892578c0ce120093116.webp',
        caption: 'ヒトのカラダとアミノ酸 / ブランディング設計強化・タンパク質知るコト',
      },
      {
        src: '/assets/migrated/adf877b13ce817fef441.webp',
        caption: 'ロゴシンボル レギュレーション案 A方向 — a + ! + Solution / フィボナッチ整数・9角形モチーフ',
      },
      {
        src: '/assets/migrated/0ab65d0e4349fad0f7d2.webp',
        caption: '確認：今後のアミノインデックス — 「食と健康の課題解決企業」構築の一翼を担う事業を目指す',
      },
      {
        src: '/assets/migrated/9e876e9480a7c650b428.webp',
        caption: 'コミュニケーションコピー付きロゴレギュレーション案 A案 — 「未来を見据え、イマを知る。」',
      },
      {
        src: '/assets/migrated/3bee1b44f93d9a5819a2.webp',
        caption: 'カラーレギュレーション案 / コミュニケーションコピー付きロゴレギュレーション案 A案・B案・C案',
      },
      {
        src: '/assets/migrated/004412cee4f511a0b9c9.webp',
        caption: 'ロゴタイプの選定 / ロゴレギュレーション案 A案・B案・C案 — オリジナルサンセリフ体・学参欧文・rodin',
      },
      {
        src: '/assets/migrated/3be0ea8cd26f19a2945d.webp',
        caption: 'コミュニケーション設計 — リスクを知る。価値を知る。真の未病ケアブランドを確立させる',
      },
      {
        src: '/assets/migrated/593379b40ad0ac1d2937.webp',
        caption: 'リサーチ設計とブランド認知・利用実態把握 — 生活改善ソリューションサービス +αバリュー',
      },
      {
        src: '/assets/migrated/c9c2943c0790d1ff3d24.webp',
        caption: 'アミノインデックスも栄養と健康を考えるファクターとなる — 未病ケア促進・予防の機会創出・ブランド価値ビジョン',
      },
      {
        src: '/assets/migrated/4586218244457757c291.webp',
        caption: 'ロゴシンボル レギュレーション案 C方向 — A + I + Support / 黄金比・「いのち」を表すハート',
      },
      {
        src: '/assets/migrated/81ead2f16f686c285a6a.webp',
        caption: 'ロゴシンボル レギュレーション案 A方向/B方向/C方向/その他 — a+i+amino / a+i+heart / a+i+tours / !+heart',
      },
      {
        src: '/assets/migrated/cc48a2ca55484a954d52.webp',
        caption: 'amino !ndex ロゴマーク（赤）— 完成ロゴデザイン',
      },
    ],
  },
  {
    id: 'unite-card',
    project: 'UNiTe Card',
    client: 'Nishitetsu Store / Nishi-Nippon Railroad',
    year: '2021–2022',
    category: 'Brand / Retail / TV-CM',
    role: 'VI / Brand Strategy / Naming / Logo / Retail / Web / TV-CM',
    issue: '新ポイントカードを、機能説明だけではなく地域生活者との関係を示すブランドとして立ち上げる。',
    challenge: '「ポイントが貯まる」という機能だけでなく、地域生活者に愛着を持ってもらえるブランド価値を生むこと。',
    insight: '「貯まる」から「つながる」へ。カードを通じて店と生活者の関係を育む体験が鍵。',
    strategy: '「UNiTe（つなぐ）」というネーミングで、店舗・地域・生活者をつなぐブランドを構築。',
    experience: 'カード、店頭、ウェブ、TV-CMを通じた統一体験。買い物のたびに生まれる関係性を設計。',
    output: 'ネーミング、ロゴ、VI、店頭ツール、ウェブ、TV-CM、コミュニケーション。',
    impact: 'ポイントカードの新規登録拡大と、地域生活者との関係構築を実現。',
    images: [
      {
        src: '/assets/migrated/01938f456f5188e0758b.webp',
        caption: 'Hero Visual — UNiTe Card ブランドオーバービュー',
      },
      {
        src: '/assets/migrated/0514b71cb8c994fed5a9.webp',
        caption: 'デザインアプリケーション展開 — カード・バナー・タペストリー・裏面デザイン',
      },
      { src: '/assets/migrated/59a739d698dbd7cec668.png', caption: 'Naming / Brand Concept' },
      {
        src: '/assets/migrated/de1816beade7957baa80.webp',
        caption: 'UNiTe Card カードデザイン — Rakuten Point Card × Edy機能付きポイントカード',
      },
      {
        src: '/assets/migrated/48d599bd7c1c22d10ba5.webp',
        caption: 'ユナイトカード — にしてつストア全店の新・ポイントカード（Rakuten Point Card / Edy機能付き）',
      },
      {
        src: '/assets/migrated/bf2fbe6eb1eb0e392b71.webp',
        caption: 'Web / デジタルデザイン — UNiTe Card 公式サイト',
      },
      {
        src: '/assets/migrated/7508e956fe082e93bb0e.webp',
        caption: 'PROPOSAL PLAN — E案・F案・確定案の4パネル統合提案とブランドコンセプト',
      },
      {
        src: '/assets/migrated/e30341997de874156d4c.webp',
        caption: 'デザインイメージ 書体A ① — UNiTe Card ロゴタイプとカラフルリングデザイン',
      },
      {
        src: '/assets/migrated/36b354f376139f2f43f0.webp',
        caption: 'Think of "Look" DESIGN — Ni Raku CardからUNiTe Cardへのデザイン進化',
      },
      {
        src: '/assets/migrated/ad39870bbdc185edf110.webp',
        caption: 'デザインイメージ ① — ポスター・タペストリー・バナー展開',
      },
      {
        src: '/assets/migrated/1b8e2bed2e3838ee7b64.webp',
        caption: 'ネーミングおよびデザインについて — U = YOU + NISHI + TETSU、「あなたをつなぐ、にしてつストア」',
      },
      {
        src: '/assets/migrated/20ea3fb3398cadf006d9.webp',
        caption: 'デザイン企画全体 — LOOK手法でブランドデザインの表層を統一したクリエーティブ展開',
      },
      {
        src: '/assets/migrated/f62710ab6a09b20d9f76.webp',
        caption: 'デザインコンセプト — その地に暮らす生活者 = YOU = U、5つのカラーとステークホルダー設計',
      },
      {
        src: '/assets/migrated/702cb9d1957fb211d0de.webp',
        caption: 'デザインイメージ ② — ポイントカード・会員募集販促物・バナー展開',
      },
      {
        src: '/assets/migrated/470531e023ca77ec85e8.webp',
        caption: 'デザイン企画提案書 — Web展開・カードE案・F案・確定案の統合提案',
      },
      {
        src: '/assets/migrated/1ac6691e8653b31817a3.webp',
        caption: 'デザイン企画提案書 ② — カードE案・F案・確定案の比較提案',
      },
      {
        src: '/assets/migrated/23fad16567f60ed4e7b6.webp',
        caption: 'カードレイアウト案 — 書体A/Bパターン × レイアウト①②③ の比較検討',
      },
      {
        src: '/assets/migrated/5fbacc291c122ad8ebb5.webp',
        caption: 'ユナイトカード ネーミング案・デザイン案 — 表紙・コンセプトページ',
      },
      {
        src: '/assets/migrated/f887ba67cdfd0d3149dc.webp',
        caption: 'VIブランディング企画・LP設計 — LOOk手法で統一したクリエイティブ展開と店頭導入実績',
      },
      {
        src: '/assets/migrated/5a0e80f1e2172157433d.webp',
        caption: 'UNiTe Card ブランドビジュアル — カードデザイン・キービジュアル',
        large: true,
      },
    ],
  },
  {
    id: 'green-infra',
    project: 'グリーンインフラプロジェクト',
    client: '横瀬町 / TISI Inc.',
    year: '2025',
    category: 'GI / GX Branding / Regional Experience / Spatial',
    role: 'Brand Strategy / Naming / VI / Experience Design / Spatial / Creative Direction',
    issue: '地域資産（グリーンインフラ・Green Festival Gate・森側 MORIGAWA）が点在し、それぞれの価値が一つの体験として認識されにくい状況を、ブランディングの視点から再構成。',
    challenge: '環境価値を抽象的に伝えるのではなく、地域・現場・楽しさのストーリーとして届けること。',
    insight: '「森のインターフェース」という比喩で、環境と人をつなぐ装置としてブランドを捉え直す。「横瀬」の地名が持つ「山と人が出会う場所」の意味を現代の体験デザインとして蘇らせる。',
    strategy: 'グリーンインフラを「森のインターフェース」と定義。Green Festival Gate・森側 MORIGAWA・地域共創拠点などを「グリーンインフラ グランド」というブランドに統合。',
    experience: '入口から祭りの会場、散策ルート、飲食、買い物まで一つの体験として設計。ブランド体験、サイン、ウェブ、イベントを通じて、環境と人の接点をデザイン。',
    output: 'Naming / Logo / VI / Sign / Spatial Design / Event Design / Brand Strategy / Communication',
    impact: '地域ブランドの確立と認知向上。観光・移住・地域活性化の接点創出。グリーンインフラへの理解と関与の拡大。',
    images: [
      { src: '/assets/migrated/fea614222907288bafdc.png', caption: 'Hero Visual — グリーンインフラ グランド Brand Concept' },
      { src: '/assets/migrated/d00b4f9f53e40dd93cd1.png', caption: 'Brand Identity / VI System' },
      { src: '/assets/migrated/6d4e64a44014b89e6a1f.png', caption: 'Brand Strategy / GI Concept' },
      { src: '/assets/migrated/d8c7ecf50b3391bb025b.png', caption: 'Sign / Spatial Design' },
      { src: '/assets/migrated/c9677f7d640f7cca92df.png', caption: 'Experience Design / Festival Gate' },
      { src: '/assets/migrated/9d37daffcc093e43f6d8.png', caption: 'Communication Design' },
      { src: '/assets/migrated/1b9ca8be2cb5a9c0c952.png', caption: 'Visual Identity System' },
      { src: '/assets/migrated/557967e20823ccea9787.png', caption: 'Retail / Promotional Materials' },
      { src: '/assets/migrated/0757d3645171d8afba3c.png', caption: 'Regional Brand Story' },
      { src: '/assets/migrated/d71abde4ab6fe41c0533.png', caption: 'Brand Application / Touchpoint' },
      { src: '/assets/migrated/bf7ddedc4f75e47e0362.webp', caption: '中心地のランドスケープデザイン（ベンチマーク）— Comoris Urban Share Forest。都会の人に森との接点をつくるアーバンシェアフォレストキット' },
      { src: '/assets/migrated/8586afc95e15afc831b4.webp', caption: 'ICONIC Branding / Design PLAN — YOKOZEMACHI GREEN FESTIVAL GATE ブランディング・空間デザイン' },
      { src: '/assets/migrated/eedef292490f74dca6ab.webp', caption: '「GREEN RELATION」に掛け合わせる横瀬町の既存アセット候補 — 自然・公共・民間・観光の4分類で整理' },
      { src: '/assets/migrated/ff098b7218add5b5efce.webp', caption: '森のinterface — スマートフォンのアプリのように触って・試して・調べて・学んで・工夫して。みんなで森を活かし守るキッカケをつくる' },
      { src: '/assets/migrated/c7894e905e8cd4cc6a9d.webp', caption: '中心地のグリーンインフラとしての機能的役割 — 「森のinterface」としての中心地から達成する目的の明確化と町内のアセットを活かした手段の検討' },
      { src: '/assets/migrated/cc69755da05378d56c65.webp', caption: 'ICONIC Branding / Design PLAN — YOKOZEMACHI GREEN FESTIVAL GATE ロゴタイプ・グリッド構成デザイン' },
      { src: '/assets/migrated/7e4020fdb2957a0f65b4.webp', caption: 'Our Goal — 地域内外の人びとが周辺の自然に関心を持ち、関わり活用することで自然という宝物を護りながら地域から新しい価値を共創し続ける' },
      { src: '/assets/migrated/03f6f35bd125f706be98.webp', caption: 'ICONIC Branding / Design PLAN — 駅広告・プロモーション展開（JR池袋駅・西武池袋駅・屋外広告）' },
      { src: '/assets/migrated/28cfdbeabe4640d4b6e0.webp', caption: 'Land scape Design / ゾーニング PLAN — Wellness・Creation・Activation・Open Gate・Sustainability の5ゾーン構成' },
      { src: '/assets/migrated/56403f2effebba244615.webp', caption: 'YOKOZEMACHI GREEN FESTIVAL GATE 入口 — 「さあ、ゲートをくぐろう！」実写写真' },
    ],
  },
  {
    id: 'saitama-wood-terrace',
    project: 'SAITAMA WOOD TERRACE',
    client: 'SAITAMA WOOD TERRACE Project',
    year: '2025',
    category: 'Brand Story / Motion / Promotion',
    role: 'Creative Direction / Motion / Communication',
    issue: 'ウッドテラスという地域ブランドの認知拡大と、木の温もりを伝えるコミュニケーションが必要だった。',
    challenge: '木の質感・自然・地域の価値を、映像とナレーションで感情的に昇華させること。',
    insight: '「人の声」がナレーションに乗ることで、ブランドに温かみと物語性が生まれる。映像の持つ「時間の流れ」が、木と暮らす生活の豊かさを最もよく伝える。',
    strategy: '映像×ナレーションで「木と暮らす」世界観を構築。プロモーション映像を単なる説明ツールではなく、ブランドの世界観を体験させるメディアとして位置づける。',
    experience: 'ナレーション設計から映像演出まで、ブランドへの感情的な接続を生む体験を設計。',
    output: 'プロモーション映像（ナレーション設計付き）、コミュニケーション設計、ブランドストーリー',
    impact: 'ブランド認知と共感の向上。地域素材・企業との協働イメージ形成。',
    images: [
      { src: '/assets/migrated/5dd6214f011e3a268870.png', caption: 'Hero Visual — SAITAMA WOOD TERRACE Brand Overview' },
      { src: '/assets/migrated/missing-transparent.gif', caption: 'Film Scene — Wood Terrace Location' },
      { src: '/assets/migrated/7e049d09362a4fdb1663.jpg', caption: 'Forest Environment / Natural Setting' },
      { src: '/assets/migrated/cd81188f85651bfcdb50.jpg', caption: 'Wood / Material Story' },
      { src: '/assets/migrated/fca833452b6b2f59e294.jpg', caption: 'Brand World View' },
      { src: '/assets/migrated/7a1be5d5532ee97355b8.jpg', caption: 'Lifestyle / Space Experience' },
      { src: '/assets/migrated/70dfcc35427e94aaa690.jpg', caption: 'Film Final Scene' },
      { src: '/assets/migrated/4f63ad602daf47f1671f.jpg', caption: 'テラス建築・構造美' },
      { src: '/assets/migrated/d6ba53fc5da994e16165.jpg', caption: '埼玉の森・自然と木の重なり' },
      { src: '/assets/migrated/f8cc23ec0dd04554e875.jpg', caption: '地域住民・使い手の姿' },
      {
        src: '/assets/migrated/201f25686ee38314bfd7.webp',
        caption: '映像の流れと構成要素 — ブランディング動画の5構成要素（A:掴み・B:埼玉材の特長・C:JAS材の信頼性・D:木育と未来・E:クロージング）と訴求メッセージ設計',
      },
      {
        src: '/assets/migrated/7b2daa529aca8dad0aed.webp',
        caption: '構成要素の詳細と絵コンテのスキーム — 7シーンの詳細絵コンテ・テロップ・BGM・訴求ポイント（ページ18）',
      },
      {
        src: '/assets/migrated/87e4d57e069a5ab9997a.webp',
        caption: 'LOGO DESIGN 確定案 — 家のシンボルに葉を添えたロゴマーク（黒/緑バリエーション）',
      },
      {
        src: '/assets/migrated/59dc2b098d27d55f4f5f.webp',
        caption: 'LOGO DESIGN 確定案 — 6パターンのロゴレイアウトバリエーション（縦組・横組・丸囲みなど）',
      },
      {
        src: '/assets/migrated/5cbad2f6b70dab1ebd30.webp',
        caption: 'PR動画/全体キャプションコピー — ブランドコピー集（都心近くの森から信頼を"みらい"へ届けたい、JASマークの品質保証、心地よい"みらい"をつくろう）',
      },
      {
        src: '/assets/migrated/6645bc9ac95ed01bb445.webp',
        caption: 'はじめに- ブランディング動画企画 Design PLAN — プロジェクトブランドデザイン「SAITAMA WOOD TERRACE • PROJECT •」ロゴ構成とデザイン意図',
      },
      {
        src: '/assets/migrated/0d580ae8d84f04fa80a5.webp',
        caption: '構成要素の詳細と絵コンテのスキーム — 7シーン（掴み・導入・地産地消・エコ・森の循環・JASの安心・木育と未来・クロージング）の詳細設計（ページ17）',
      },
      {
        src: '/assets/migrated/7b8122f2045ca946682d.webp',
        caption: 'LOGO DESIGN 確定案 — 円形バッジロゴ（黒/緑バリエーション）',
      },
      {
        src: '/assets/migrated/9fd68ced0450d04330b3.webp',
        caption: 'LOGO DESIGN 確定案（縦組）— 家のシンボルに葉を添えた縦組ロゴマーク',
      },
      {
        src: '/assets/migrated/c57e8520fac33f4ecb39.webp',
        caption: 'LOGO DESIGN キービジュアル — 埼玉の森林上空にロゴを重ねたキービジュアル（新緑・紅葉）',
      },
    ],
    videos: [
      {
        src: '/assets/migrated/8a12994571dc26e04e39.mp4',
        caption: 'SAITAMA WOOD TERRACE PR動画',
      },
    ],
  },
  {
    id: 'aqua-park-shinagawa',
    project: 'アクアパーク品川 ブランディング',
    client: 'エプソン品川アクアタウン / 株式会社横浜八景島',
    year: '2015',
    category: 'Facility Rebranding / Launch / VI / Event / Spatial',
    role: 'Creative Direction / Communication / Spatial / Launch / VI Design',
    issue: '2015年7月、10周年を迎えるエプソン品川アクアスタジアムは、国際戦略総合特区となった品川の新しいエンターテイメント施設として生まれ変わる必要があった。名前も、設備も、楽しみ方も、そのすべてが変わるリブランディングが課題。',
    challenge: '「品川にある水族館」から「品川にしかないエンターテイメント施設」へ。単なるリニューアルではなく、まったく新しいカテゴリとして認知させること。電通と共同でVI/LOGOデザイン提案を行い、一貫したブランド世界観を構築する必要があった。',
    insight: '音楽・映像・光・生き物が一体化した没入体験こそが、新しいAQUA PARKの本質。SNS時代に「五感で楽しむ・拡散したくなる」体験が来場意欲を生む。「遊びによくばりな街。」というコミュニケーションコンセプトが、品川という街のエンターテイメントフラッグシップとしての魅力を最大限に引き出す。',
    strategy: '「遊びによくばりな街。」をコミュニケーションコンセプトに、EPSON AQUA TOWNブランドのVI/LOGOデザイン（電通と共同）から、リニューアル前のカウントダウンOOH、リニューアル時のスタッフ衣装・100人レインボーダー企画、リニューアル後のイベントグラフィックまで一貫した世界観を設計。A案（虹色グラデーション）とB案（SEANA SHINAGAWA）の2方向性でロゴ・ネーミングを提案。',
    experience: 'リニューアル前のカウントダウンOOH（7日〜1日）で「遊びによくばりな街。」の期待感を品川の街全体に醸成。リニューアル時の100人レインボーダー企画で、レインボー柄コスチュームを着た100人が品川の街に登場し「品川＋レインボーダーロゴ」を拡散。スタッフ衣装もレインボートーンで統一し、リニューアル感を強化。リニューアル後の「AQUA BROSSOM」「AQUA STARS」など季節イベントでファン化を促進。',
    output: 'Brand Strategy / Creative Plan / VI・LOGO Design / OOH / Event Design / Staff Uniform / 100人レインボーダー企画 / Movie / Spatial Design / Sign / Promotion',
    impact: '2015.7.1リニューアルオープン。施設ローンチ時に大きな話題を形成。来場者数の増加に貢献。品川の街全体を巻き込んだブランディング展開により、「品川＝アクアタウン」という認知の確立に寄与。',
    images: [
      { src: '/assets/migrated/c62ecf4f9669845e9b94.png', caption: 'Hero Visual — Brand Overview' },
      { src: '/assets/migrated/ad329e3ec3625f23e67e.png', caption: 'Brand Concept — EPSON AQUA TOWN VI/LOGOデザイン提案' },
      { src: '/assets/migrated/6deef4f76d110b489be7.png', caption: 'Visual Identity' },
      { src: '/assets/migrated/5faa1c5bf9e945af182f.png', caption: 'Spatial / Sign Design' },
      { src: '/assets/migrated/6018f5a61233cb61d33c.png', caption: 'Communication Design' },
      { src: '/assets/migrated/937067323a497476f7df.png', caption: 'Promotion Tools' },
      { src: '/assets/migrated/289ab8e712ed1bce7653.png', caption: 'Event / Launch' },
      { src: '/assets/migrated/dd069cf28d7496615e12.png', caption: '施設演出・没入デザイン' },
      {
        src: '/assets/migrated/87545757a4b3d912af76.webp',
        caption: 'リニューアル前→時→後 全体ブランディング展開（B案 AQUA STADIUM2含む）',
      },
      {
        src: '/assets/migrated/fe504c8ac50fe6794fde.webp',
        caption: 'SEANA SHINAGAWA ネーミング・ロゴデザイン — コンセプト・ロゴバリエーション（2F Aquarium/1F Entertainment/Night/Day/ONE WAY）',
      },
      {
        src: '/assets/migrated/1f403646a7d33d316c95.webp',
        caption: 'リニューアル時/スタッフ衣装・100人レインボーダー企画・イベントグラフィック（AQUA BROSSOM / AQUA STARS）',
      },
      {
        src: '/assets/migrated/66572e9e0bffe404f83a.webp',
        caption: 'リニューアル前→時/グラフィック — AQUA STADIUM2 リニューアルCM出演者募集（イルカ/カピバラ/クラゲ/ヒトデ）',
      },
      {
        src: '/assets/migrated/0613f2bf44a5353d98cd.webp',
        caption: 'リニューアル時グラフィック・工事現場ツール・除幕式・入口装飾 — レインボーダートーン統一',
      },
      {
        src: '/assets/migrated/e5128b23e557153e0f49.webp',
        caption: 'A案 リニューアル前/カウントダウンOOH — 「遊びによくばりな街。」AQUA TOWN リニューアルまでのカウントダウン広告（7日〜1日）',
      },
      {
        src: '/assets/migrated/f1a928c302209da38b73.webp',
        caption: 'B案 リニューアル前→リニューアル時/入口 — EPSON AQUA STADIUM 2 入口デザイン。リニューアル感を強める',
      },
      {
        src: '/assets/migrated/9268bdb9c4e252f5a4b5.webp',
        caption: 'B案 ネーミング・ロゴ — 「品川のよくばりな水族館。」EPSON AQUA STADIUM 2 ロゴデザイン',
      },
      {
        src: '/assets/migrated/337a053c37b93701d563.webp',
        caption: 'C案 ネーミング・ロゴ — SHINAKURU SHINAGAWA。無限大の記号を用いて、長く愛されずっと楽しめるエンターテイメント施設を表現',
      },
      {
        src: '/assets/migrated/33d34520257360311e0d.webp',
        caption: 'B案 考え方 — AQUA STADIUM 2 CM企画。品川のリアルな場所を舞台に、街の人々と水族館スタッフが一緒に作るイベントテレビCM',
      },
      {
        src: '/assets/migrated/4adc210261f72c545151.webp',
        caption: 'maxell AQUA PARK SHINAGAWA 入口 — リニューアル後の実写写真',
      },
      {
        src: '/assets/migrated/bca708be41b978fa607f.webp',
        caption: 'B案 リニューアル前/グラフィック・ロゴ別案 — SEANA SHINAGAWA 「たのシーナ！おいシーナ！あたらシーナ！」2015.7.1リニューアル告知',
      },
      {
        src: '/assets/migrated/9cae611d0a69e16fb451.webp',
        caption: 'AQUA PARK SHINAGAWA 入口実写 — EPSON AQUA PARK（昼）/ maxell AQUA PARK（夜・レインボー照明）/ 7.10 GRAND OPEN! 壁面広告 / リニューアル後外観',
      },
      {
        src: '/assets/migrated/fdfd774505b5d1d82f6e.webp',
        caption: 'アクアパーク品川 ブランディング — リニューアル告知・ブランドビジュアル',
        large: true,
      },
    ],
    videos: [
      {
        src: '/assets/migrated/0243f9604d56a3ab8df0.mp4',
        caption: 'AQUA PARK SHINAGAWA PR動画',
      },
    ],
  },
  {
    id: 'nisshin-petfood-tvcm',
    project: '日清ペットフード TV-CM',
    client: '日清ペットフード',
    year: '2016',
    category: 'TV-CM / Advertising / Communication',
    role: 'Creative Direction / TV-CM / Communication Strategy',
    issue: 'ペットフード市場での認知向上と、ブランドへの感情的なつながりを形成する。',
    challenge: '機能訴求ではなく、「ペットとの愛情ある関係」を軸にしたブランドコミュニケーションへの転換。',
    insight: 'ペットへの愛情は、飼い主の生活の中で自然に存在するもの。そこを起点に訴えかける。',
    strategy: '愛情ある日常の瞬間を捉えたストーリーラインで、感情的な共感を生む。',
    experience: 'TV-CMを起点に、感情的なブランド接続を構築。',
    output: 'TV-CM複数本（15秒バリエーション）、コミュニケーション設計',
    impact: 'ブランド好意度の向上。ペットとの関係性を軸にした感情的なポジションの確立。',
    images: [
      {
        src: '/assets/migrated/6bc55119f8e1854c3c39.webp',
        caption: 'Hero Visual — CM Overview',
      },
      {
        src: '/assets/migrated/d6a56e72958a9e41e642.webp',
        caption: 'NEW いぬのしあわせ / プッチーヌ — 日清ペットフード パッケージデザイン・コミュニケーション戦略',
      },
      {
        src: '/assets/migrated/fa89c04a8700b683da5f.webp',
        caption: '日清ペットフード TV-CM PLAN — パッケージ・コミュニケーション戦略',
      },
      {
        src: '/assets/migrated/d43aeabf1610d5776c3f.webp',
        caption: 'TVCF企画のご提案 — タイトル・目的「ブランド認知、ブランド共感を通じて購買につなげる」',
      },
      { src: '/assets/migrated/791ea32f296582e221e6.webp', caption: 'NEW いぬのしあわせ / プッチーヌ — 日清ペットフード パッケージデザイン' },
      { src: '/assets/migrated/16e3cd37734783997842.webp', caption: 'E「オーナーの気持ち」篇 15秒 — 愛犬とオーナーのしあわせをドキュメンタリーで表現' },
      { src: '/assets/migrated/be74aeb04f364471608f.webp', caption: 'TV-CM企画の考え方 — ブランド共感「ずーっと元気を、小さいころのゴハンから。」購買につなげるためのブランドスイッチ戦略' },
      { src: '/assets/migrated/83af810424b24efcdfd2.webp', caption: 'F「先輩は語る」篇 15秒 — 健康情報番組のテロップの真ん中に、ご長寿犬。おじいさん犬が長生きの秘訣を語る' },
      { src: '/assets/migrated/957dcb8977a178379d47.webp', caption: 'A-1「おねだりの天才」篇（いぬのしあわせ ver）/ A-2「おねだりの天才」篇（プッチーヌ ver）15秒' },
      { src: '/assets/migrated/5f2a3906005defb8dad0.webp', caption: '日清ペットフード TV-CM PLAN — NEW いぬのしあわせ / プッチーヌ パッケージ・コミュニケーション戦略' },
      { src: '/assets/migrated/a7652d16aea5bcf3cc93.webp', caption: 'どう購買につなげるか？— 愛犬の成長段階の早いタイミングで商品を勧めるシェア拡大戦略 / メッセージ開発の方向性' },
      { src: '/assets/migrated/860c69d31eec37036304.webp', caption: 'B「食べるしあわせ」篇 15秒 — 愛犬がゴハンを食べる姿を愛らしく表現。商品名を犬種とともにキャッチーな歌い込みで印象付ける' },
      { src: '/assets/migrated/240f82d9715e0c2adcab.webp', caption: '課題とミッション — ベストバランスと機能性で差別化は難しい。購買につながるブランド共感メッセージをつくる' },
      { src: '/assets/migrated/1f5672d846393157386c.webp', caption: 'TVCM企画 A「おねだりの天才」篇 — ブランド認知＆共感を獲得できる表現で7案。ブランドネーミング訴求からブランドスイッチ訴求へ' },
      {
        src: '/assets/migrated/c7f4fdd322554c6b8842.webp',
        caption: 'メッセージ & TV-CM企画の考え方 — ブランド共感「ずーっと元気を、小さいころのゴハンから。」',
      },
      {
        src: '/assets/migrated/d36b14656ab468f83fdf.webp',
        caption: 'E資料 + F「先輩は語る」篇 — 参考資料とブランドスイッチ訴求',
      },
      {
        src: '/assets/migrated/fdf818aff3666e4194ba.webp',
        caption: 'D「ママとぼくのしあわせ」篇 15秒 — TV-CMストーリーボード',
      },
      {
        src: '/assets/migrated/3289054daaf5c47515ee.webp',
        caption: 'C「ゴハンを待つワンちゃん」篇 — TV-CMストーリーボード',
      },
      {
        src: '/assets/migrated/7fed95c01b3c7973e666.webp',
        caption: 'C参考資料 + D「ママとぼくのしあわせ」篇 — 参考資料と愛犬目線の共感演出',
      },
    ],
    videos: [
      {
        src: '/assets/migrated/d6732ff34a68c58236fa.mp4',
        caption: 'A-1「おねだりの天才」篇（いぬのしあわせ ver）15秒',
      },
      {
        src: '/assets/migrated/016f3a3480e70dc3eafb.mp4',
        caption: 'A-2「おねだりの天才」篇（プッチーヌ ver）15秒',
      },
      {
        src: '/assets/migrated/f07d24863735546c3fe1.mp4',
        caption: 'B「食べるしあわせ」篇 15秒',
      },
      {
        src: '/assets/migrated/8d0ab07268e0380a449f.mp4',
        caption: 'C「ゴハンを待つワンちゃん」篇 15秒',
      },
      {
        src: '/assets/migrated/e1e4331e30cb43e98599.mp4',
        caption: 'D「ママとぼくのしあわせ」篇 15秒',
      },
    ],
  },
  {
    id: 'paper-glass',
    project: 'PAPER GLASS',
    client: 'PAPER GLASS',
    year: '2015',
    category: 'Product / Promotion / Creative',
    role: 'Creative Direction / Promotion / Communication Design',
    issue: '紙製グラスという新しいプロダクトカテゴリを市場に定着させ、その価値を伝える。',
    challenge: 'プラスチックとも紙コップとも違う、全く新しいプロダクトの位置づけを作ること。',
    insight: '「ちょっと掛けるのにちょうどいい」——素材の触感・見た目・エコ意識の3つが交差するポイントに、新しい体験価値がある。',
    strategy: '「ちょっと掛けるのにちょうどいい」というコミュニケーションコンセプトで、気軽さとちょうど良さをデザイン。プロダクトとコミュニケーションを統合設計。',
    experience: 'パッケージ、POP、販促ツールを通じた統一した購買体験の構築。',
    output: 'プロダクトコンセプト、パッケージデザイン、プロモーションツール、コミュニケーション設計',
    impact: 'カテゴリ認知の形成と市場への定着。',
    images: [
      { src: '/assets/migrated/15c7fbd5bfdc974b568e.webp', caption: 'Hero Visual — Product Overview' },
      { src: '/assets/migrated/45c8d4116653b49cf1ed.webp', caption: 'Paperglass mini — ちょっと掛けるのにちょうどいい' },
      { src: '/assets/migrated/2be40927466dff909ca7.webp', caption: '鯖江・薄型めがね ペーパーグラス — Good Design Award BEST 100' },
      { src: '/assets/migrated/164aefe644aa3b80626d.png', caption: 'Retail / POP Design' },
      { src: '/assets/migrated/c2d930bc24506e38150f.webp', caption: 'Promotion Materials' },
      { src: '/assets/migrated/98c7bd48e8ec9c1076bb.webp', caption: 'Communication Design' },
      { src: '/assets/migrated/9cfddb0f55358cffc9ab.webp', caption: '戦略・施策ロードMAP — 施策一覧と予算・優先順位設計' },
      { src: '/assets/migrated/26903e4d860efb33cdc5.webp', caption: 'Final Output' },
      { src: '/assets/migrated/09dff93131d8963c1548.webp', caption: '戦略・施策ロードMAP — 購買ファネルを軸としたコミュニケーションプラン設計' },
      { src: '/assets/migrated/545d63a147eb30cfa17b.webp', caption: 'カスタマージャーニーMAP — ユーザー購買行動を見ながらタッチポイント明確化させた施策設計' },
      { src: '/assets/migrated/e559b39270bd5c1c1795.webp', caption: 'ペーパーグラス・ミニ シリーズ — ちょっと掛けるのにちょうどいい' },
      { src: '/assets/migrated/d2234c021dc8207c99e0.webp', caption: '購買プロセスを前進させるツール構成 — 認知→関心→選択→共感の接点設計' },
      { src: '/assets/migrated/ee58343a3a3944e6785a.webp', caption: '施策一覧表 — 戦略・施策ロードMAPと予算・優先順位設計' },
      {
        src: '/assets/migrated/aaeb1387555a00158b8f.webp',
        caption: '店頭ツール施策 — 認知→関心→選択→共感の接点設計',
      },
      {
        src: '/assets/migrated/de779392d2fe7d207ec0.webp',
        caption: 'SNS運用改善事例 — 職人の顔と出来上がった商品で温かみを伝える',
      },
      {
        src: '/assets/migrated/f537921222edb7748948.webp',
        caption: 'ツールリスト表 — 購買ファネル別店頭ツール設計（認知→関心→選択→共感）',
      },
      {
        src: '/assets/migrated/75573b25953df89e615d.webp',
        caption: 'Paperglass mini — ちょっと掛けるのにちょうどいい（縦書き版）',
      },
      {
        src: '/assets/migrated/f9b89d65edeab7f3da9d.webp',
        caption: 'Paperglass mini & Sunglasses — iF DESIGN AWARD 2019受賞',
      },
      {
        src: '/assets/migrated/102056044f8e3b747f71.webp',
        caption: '実店舗ツール設置プラン — 福井駅前店・東京帝国ホテル店・大阪淀屋橋odona店',
      },
    ],
  },
  {
    id: 'reganet',
    project: 'Reganet',
    client: 'Reganet',
    year: '2012',
    category: 'Retail CI / VI / Spatial',
    role: 'CI / VI / Spatial Design / Communication',
    issue: 'リテールブランドとしての認知が低く、店頭での差別化が不十分だった。',
    challenge: '機能訴求中心の市場で、感情価値を伴うブランドとしての顔を作ること。',
    insight: 'パッケージは「商品の顔」であり、棚の中で選ばれる理由になる。一貫したロゴ・カラー・パッケージデザインが、ブランドの信頼感と購買欲を同時に生む。',
    strategy: 'ブランドアイデンティティを「ロゴ・カラー・パッケージ」三位一体で構築。店頭での視認性と、手に取った時の品質感を両立させるデザイン設計。',
    experience: 'パッケージデザイン、店頭ディスプレイ、販促ツールを通じた統一されたブランド体験。',
    output: 'Logo Design / Color System / Package Design / VI / Retail Tool',
    impact: 'ブランド認知向上と店頭での選ばれる理由の創出。',
    images: [
      { src: '/assets/migrated/4ae9ee25415b3f3b32ed.webp', caption: 'Hero Visual — Brand Overview' },
      { src: '/assets/migrated/3e5349c6c0c7ee5de744.webp', caption: 'CI / VI System' },
      { src: '/assets/migrated/fc09e6a8c941856ff972.png', caption: 'Logo / Brand Identity' },
      { src: '/assets/migrated/53926d9640f4634d50fb.webp', caption: 'Color / Typography System' },
      { src: '/assets/migrated/8c3686590801b3f4d7ca.png', caption: 'Spatial / Sign Design' },
      { src: '/assets/migrated/fc3501ef45695473aaa6.webp', caption: 'Store Interior' },
      { src: '/assets/migrated/e2caed8a506815a657c9.png', caption: '店内ツール / 販促物！' },
      { src: '/assets/migrated/58fefed9ffc351512089.jpg', caption: '実店舗誘導サイン・誘導実施写真' },
      { src: '/assets/migrated/reganet0001-user-supplied.png', caption: 'Reganet DAILY ENTERTAINMENT SQUARE — 店頭外観 / ロゴサイン実施写真' },
      { src: '/assets/migrated/missing-transparent.gif', caption: 'Reganet ロゴデザイン — シンボルマーク単体（オレンジ）' },
      { src: '/assets/migrated/missing-transparent.gif', caption: 'カラーレギュレーション案 — 子鴨色ベース（現行踏襲）/ グリーン系2トーン / 暖色系オレンジ 3方向の比較' },
      { src: '/assets/migrated/8c3686590801b3f4d7ca.png', caption: 'ロゴタイプ修正前後 — シンボルマーク断面詳細図（Stアクリル切り文字・LED白6500K）' },
      { src: '/assets/migrated/e2caed8a506815a657c9.png', caption: '施工中の店舗内部 — 九州屋コーナー・西鉄バス展示・什器設置状況' },
      { src: '/assets/migrated/missing-transparent.gif', caption: 'ロゴタイプ選定 — 黄金比グリッドによるシンボル・ロゴタイプの構成比較（3案）' },
      { src: '/assets/migrated/fc09e6a8c941856ff972.png', caption: 'にしてつストア × Reganet — 店内CGパース・青果コーナー・商品陳列イメージ' },

      { src: '/assets/migrated/0dca089f5714eacce8ce.webp', caption: 'CIロゴマーク使用ガイドライン 表紙 — にしてつストア レガネット Ver.1.0' },
      { src: '/assets/migrated/778c0a00ae8886b90f3f.webp', caption: 'ロゴデザインコンセプト — 惑星モチーフの「R」と「e」、レガーロ由来、未来に向かって発展する西鉄ストア' },
      { src: '/assets/migrated/12d1f9b3fe7589c1f21f.webp', caption: 'にしてつストア × Reganet — 店舗完成実写写真・青果・野菜売場' },
      { src: '/assets/migrated/b12c2691c0f133f5b1eb.webp', caption: 'ロゴレギュレーション④ — コンビネーションロゴ（ヨコ組み・特殊）サイズ規定と最小使用サイズ' },
      { src: '/assets/migrated/250495d83e1fab6640da.webp', caption: 'Reganet CIロゴマーク — 白抜きバージョン（オレンジ背景）' },
      {
        src: '/assets/migrated/c4f38b3fa83b826edc88.webp',
        caption: 'にしてつストア × Reganet — 店舗内観CGパース（青果/野菜/フルーツコーナー、レジエリア、売場全体）',
      },
      {
        src: '/assets/migrated/701b641300e11622c187.webp',
        caption: 'ロゴマークの基本デザイン要素 — シンボルマーク・ロゴタイプ・ブランドカラー（金赤/人参色/金茶）の定義と構成',
      },
      {
        src: '/assets/migrated/23354687eaa19ce01e51.webp',
        caption: 'にしてつストア レガネット CIロゴマーク使用ガイドライン 目次 — ロゴマークのコンセプト/基本デザイン要素/表示色/レギュレーション/背景色との関係/アイソレーション/使用禁止例',
      },
      {
        src: '/assets/migrated/e0d37898bd7405f94da0.webp',
        caption: 'Reganet ブランドビジュアル — ロゴ・VI・店頭展開',
        large: true,
      },
    ],
  },
  {
    id: 'marubeni-packetmate',
    project: '丸紅+TISI パケメイト',
    client: '丸紅 + TISI ジョイントベンチャー',
    year: '2024',
    category: 'Branding / Service / Business Design',
    role: 'Brand Strategy / VI / Web / Communication / Creative Direction',
    issue: 'ジョイントベンチャーとしての新しいブランド「パケメイト」の立ち上げ。物流・梱包領域における新しいサービスブランドとしての認知構築。',
    challenge: 'B2Bサービスでありながら、親しみやすさと信頼感の両立。技術的な優位性だけではなく、ブランドとしての魅力を持つ必要がある。',
    insight: '「梱包」はコストではなく、物流の価値を高める体験。そこにブランドの軸を置く。',
    strategy: '「パケメイト」という親しみやすいネーミングで、梱包・物流のプロフェッショナルブランドとして構築。',
    experience: 'ブランド、ウェブ、営業ツール、展示会ブースまで統一したB2Bブランド体験を設計。',
    output: 'Brand Strategy / Naming / Logo / VI / Web / Exhibition Booth / Sales Tools',
    impact: '新ブランドとして市場投入。B2B顧客への認知構築と信頼獲得。',
    images: [
      { src: '/assets/migrated/4bf15018df5927d2349b.png', caption: 'Hero Visual — Brand Overview' },
      { src: '/assets/migrated/bced483990a1066978fa.png', caption: 'Brand Concept / Strategy' },
      { src: '/assets/migrated/673aaa2c17185142596c.jpg', caption: 'Logo / VI System' },
      { src: '/assets/migrated/976145649a832fe39794.jpg', caption: 'Visual Identity' },
      { src: '/assets/migrated/12c18290b92c97940b90.jpg', caption: 'Web / Digital Design' },
      { src: '/assets/migrated/37e2e1bc854d13b62b57.jpg', caption: 'Communication Design' },
      { src: '/assets/migrated/64c75b1c04fd4f35d9a4.jpg', caption: 'Exhibition / Booth' },
      { src: '/assets/migrated/aa6bb6aee2437200ae72.jpg', caption: 'Sales Tools / Promotion' },
      { src: '/assets/migrated/17fdbb4186048760e4ac.jpg', caption: 'Brand Application' },
    ],
  },
  {
    id: 'aseed-aster',
    project: 'ASEED ASTER',
    client: 'ASAHI KASEI',
    year: 'Archive',
    category: 'Branding / Promotion / Communication',
    role: 'Brand Strategy / Communication / KEY Visual / TV-CM / Promotion',
    issue: '果実チューハイ市場で果汁率の高さという機能だけでは、檸檬堂などの上位競合との差別化が困難。新ブランドとしての独自の世界観と、若年層への入口設計が必要だった。',
    challenge: '「果汁多」という機能訴求を超えて、「飲んだら旅気分」という体験価値で差別化すること。20代の「初めて飲む酒」としてのブランドポジションを確立する。',
    insight: '若年層は「購入」より「体験・共感・自己実現」を重視。地元の素材と旬の果実をストーリー化し、「Gotochi（当地）」という発想で地域の味を旅する体験を提供すると共感が生まれる。',
    strategy: '「当地から選んだ果実の恵み」というブランドストーリーを構築。沖縄シークヮーサー、福島桃、瀬戸内レモン、愛南ゴールドの4地域をラインナップ。KEY Visualは9分割画面で旬の色彩を演出。TV-CMでは「飲んだら旅気分」を表現し、売場では「初めて飲む酒」としての親しみやすさを訴求。',
    experience: 'パッケージ、店頭POP、Web、TV-CM、販売接点を通じて統一したブランド体験。競合分析に基づいた売場戦略で、新規棚獲得と買気向上を設計。',
    output: 'Brand Concept / KEY Visual Plan / TV-CM / Package / POP / Web / Sales Floor Strategy',
    impact: '新ブランドの認知構築と、若年層・新規層への浸透。売場での訴求力向上と流通小零售の商談獲得に貢献。',
    images: [
      { src: '/assets/migrated/577984cb6edeee6ad15d.png', caption: 'Hero Visual — ASEED ASTER Brand Overview' },

      {
        src: '/assets/migrated/2c721cafc3e7a45ac276.webp',
        caption: 'Creative Update / Concept — ASEED ASTER + Gotochi ブランドコンセプト 3フェーズ設計（page 8）',
      },
      {
        src: '/assets/migrated/2db182e37fd943b1f861.webp',
        caption: 'KEY Visual Plan – Design C / D / E — 4パネル広告デザイン案（page 12）',
      },
      {
        src: '/assets/migrated/a8714ee86aab6f5dcadb.webp',
        caption: 'KEY Visual デザイン案 A/B/C/D — グラデーションと果実訴求の方向性比較（page 14）',
      },
      {
        src: '/assets/migrated/15ffcb7cc7ccb6d25365.webp',
        caption: '生活者との接点 〜カスタマージャーニーマップ〜 — 認知→興味→理解の導線設計（page 33）',
      },
      {
        src: '/assets/migrated/d0f758a011f2e19cf7d0.webp',
        caption: 'Retail Tool Plan — トップボード・POP・キャンペーンシールデザイン仕様（page 22）',
      },
      {
        src: '/assets/migrated/62e41a4134e482105d47.webp',
        caption: 'コミュニケーション設計 Creative Update !! — 表紙・現状の方向性（page 7）',
      },
      {
        src: '/assets/migrated/17865dd0752da1160551.webp',
        caption: 'TV-CM Plan — 施策②・マス広告 タイトルページ（page 23）',
      },
      {
        src: '/assets/migrated/4a9d45d5bd57b446272a.webp',
        caption: 'Retail Tool Plan — 施策①・店頭ツール タイトルページ（page 19）',
      },
      {
        src: '/assets/migrated/a4322a46296d787aef6f.webp',
        caption: 'キャンペーン施策B〈クローズド懸賞〉— ご当地・女子会うつわが当たるキャンペーン（page 27）',
      },
      {
        src: '/assets/migrated/e63da7db989608c8c68a.webp',
        caption: '生活者との接点 〜カスタマージャーニーマップ〜 page 32 — 認知→興味→検索→行動→共有の導線設計（基本フレームワーク版）',
      },
      {
        src: '/assets/migrated/28b076422948c215ce50.webp',
        caption: 'ASEED Brand Products — 4種のフルーツチューハイ製品ラインナップ紹介（英語版ブランド資料）',
      },
      {
        src: '/assets/migrated/83aa981df72d1c064995.webp',
        caption: '「ASTER」コミュニケーション DESIGN page 18 — 4パネル統合広告デザイン案（果実 splash・モデル・製品ラインナップ）',
      },
      {
        src: '/assets/migrated/fa874eebf5af20b8ebf7.webp',
        caption: '現状分析② 〜現状のマーケティングミックス検証から〜 page 3 — 4P/4C分析表と課題抽出',
      },
      {
        src: '/assets/migrated/e2d1de1c3a5e1038a1f4.webp',
        caption: '新たなコミュニケーション設計 page 5 — 「ASTER」これからの店頭施策ポイント・ブランディング戦略VISIONING',
      },
      {
        src: '/assets/migrated/ba82971dce37c2cf2e26.webp',
        caption: 'KEY Visual デザイン案 A/B/C/D page 15 — 4方向性比較：フルーティーな甘み・新鮮さ・フルーツそのもの・誠実さと手軽さ',
      },
      {
        src: '/assets/migrated/1ad42f08d7fe3d66fa61.webp',
        caption: 'KEY Visual Plan – Design B page 11 — 9分割広告レイアウトとバリエーション展開',
      },
      {
        src: '/assets/migrated/709149298ad95ededad7.webp',
        caption: '生活者との接点 〜カスタマージャーニーマップ〜 page 34 — 実際の広告素材・店頭ツール・Webサイトを配置した統合導線設計',
      },
      {
        src: '/assets/migrated/866ba06d0679bde605af.webp',
        caption: '施策実行の狙い Forecast page 30 — 生活者の買いたい気持ちをデザインする',
      },
      {
        src: '/assets/migrated/5f356c8cc682479a69f5.webp',
        caption: 'Communication Approach page 13 — 圧倒的な差別化ポイント「ご当地」、初めてお酒を飲む「アシードアスター」のクリエーティブ提案',
      },
      {
        src: '/assets/migrated/0a905d87dcc710a4386c.webp',
        caption: 'キャンペーン施策・フロー図〈クローズド懸賞〉page 29 — 店頭ツール→キャンペーンLP→購入→レシート応募の導線設計',
      },
      {
        src: '/assets/migrated/7d86f256b32e2d7821d1.webp',
        caption: 'Retail Tool Plan 店頭イメージ展開 page 21 — 実際の店頭陳列・POP・シール展開の実写写真',
      },
      {
        src: '/assets/migrated/6229d786e511974d2909.webp',
        caption: '生活者との接点 〜カスタマージャーニーマップ〜 page 31 — 認知→興味・関心→検索→行動→共有のOnline/Offline統合導線',
      },
      {
        src: '/assets/migrated/1ec0e919bb97f9fb808b.webp',
        caption: 'ASEED ASTER KEY Visual — フルーツスプラッシュとGotchiブランドメインキービジュアル',
      },
      {
        src: '/assets/migrated/081a1ad8a609105562fb.webp',
        caption: 'Creative Update / Concept page 9 — 4方向性比較：フルーティーな甘み・新鮮さ・フルーツそのもの・誠実さと手軽さ',
      },
      {
        src: '/assets/migrated/fdd2c962c948009fb12f.webp',
        caption: 'KEY Visual Plan – Moving Image page 16 — 9分割グリッド画面・商品シーンイメージの動きの詳細',
      },
      {
        src: '/assets/migrated/5a3a043eeaf4c6d78834.webp',
        caption: 'KEY Visual Plan – Moving Image page 17 — 動きある構成で各所で訴求が可能な4パネル展開',
      },
      {
        src: '/assets/migrated/cc9317455324dde11dc4.webp',
        caption: 'キャンペーン施策A〈クローズド懸賞〉page 26 — ご当地・女子会グルメが当たるキャンペーン',
      },
      {
        src: '/assets/migrated/302c2b4d387cf0a1f0bf.webp',
        caption: '施策実施の目的 page 1 — 既存棚売上支援・新規棚獲得・ASEED ASTERブランド強化',
      },
      {
        src: '/assets/migrated/d3c273a495ec47b3da39.webp',
        caption: 'Retail Tool Plan 店頭イメージ展開 page 20 — 実際の店頭陳列・POP・シール展開実写',
      },
      {
        src: '/assets/migrated/7cc48639f09da8fb87be.webp',
        caption: '現状分析① 〜競合比較〜 page 2 — 製品特徴（果汁多）競合とASEED ASTERの差別化ポイント',
      },
      {
        src: '/assets/migrated/4b5d5a1b1861105436f8.webp',
        caption: 'キャンペーン施策C〈クローズド懸賞〉page 28 — ご当地へ行こう！女子旅が当たるキャンペーン',
      },
      {
        src: '/assets/migrated/517d8d7830b13dafe510.webp',
        caption: '施策④・キャンペーンプロモーション Campaign-Plan page 25 — キャンペーン施策フローとプラン設計',
      },
      {
        src: '/assets/migrated/abf4bb3fa9fd7cfe00c8.webp',
        caption: 'KEY Visual Plan – Design A page 10 — 4種並び広告デザインと2パネルバリエーション',
      },
      {
        src: '/assets/migrated/cf6245f2d6cdcead7a88.webp',
        caption: 'VGM-IN!! page 24 — TV-CMと各種広告パターンA〜Iの総合展開ボード',
      },
      {
        src: '/assets/migrated/3229e4e7be5b57c782ba.webp',
        caption: 'NEW コミュニケーション設計図 page 6 — Gotóchiブランド・ASEED ASTER・3フェーズ構成図（商品優位性→メインコピー→商品特性）',
      },
      {
        src: '/assets/migrated/265bbfe306fa6e9c580e.webp',
        caption: '現状分析③ 〜ASEED ASTER 商品要素分解 page 4 — 商品要素分解フローチャート（お酒・缶チューハイ・濃厚国産ストレート果汁・果汁率・こだわり産地）',
      },
      {
        src: '/assets/migrated/37ea0a1474f7fb5850ab.webp',
        caption: 'ASEED ASTER 英語版キービジュアル — Fruit juice chu-hi made from carefully selected seasonal fruits（ご当地から厳選したやさしい果実の恵み）',
      },
      {
        src: '/assets/migrated/f14d35bcb1ec7219a03d.webp',
        caption: 'ASEED Brand Products — 4種のフルーツチューハイ製品ラインナップ（キッチン背景・英語版ブランド資料）',
      },
    ],
  },
  chefsPrideCase,
  remoCartCase,
  {
    id: 'token-branding',
    project: 'トークン活用型 ブランディング戦略 PROJECT',
    client: 'TISI Inc.',
    year: '2024',
    category: 'Business Design / Web3 / Brand / Web Design',
    role: 'Brand Strategy / Business Design / Service Design / Web Design / Communication',
    issue: 'Made in Japan の製品・体験は、従来の流通構造（卸・小売・EC）に依存することで、生産者と消費者の直接的なつながりが薄く、二次流通の活性化や偽造品防止、ブランド価値の正確な伝達が困難だった。また市場は2030年までに2,000兆円規模への成長が見込まれる一方、日本の製品・体験の価値がグローバルに適切に届けられていないという課題があった。',
    challenge: 'ブロックチェーン・トークン技術という複雑な仕組みを、メーカー・消費者・ブランド担当者に「自分ごと」として感じられるサービスに昇華すること。技術説明だけでなく、価値と体験の物語として伝えるブランド設計とウェブサイトデザインが求められた。',
    insight: '「強い想いを源泉に積み重んで作られた Made in Japan の製品・体験は、まさに日本の誇り。その価値をもっと広く、そして適正に届けられるべき」——トークン技術の本質は、製品の透明性確保と消費者との継続的な絆づくりにある。モノをトークン化することで、企画段階からファン化まで4つのフェーズにわたる新しいサプライチェーンが実現できる。',
    strategy: '「GLOBAL REACH WITH TOKENS — Made in Japan の製品・体験をもっと世界へ。モノのトークン化で実現する次世代のサプライチェーン」をコアコンセプトに設定。サービスを①企画・製造（予約権トークン）②流通・販売（引換権トークン）③引換・消費・体験（製品と直接交換）④ファン化（FANトークン）の4フェーズで体系化。ウェブサイトは、課題提起（Issues）→解決策（Solutions）→価値提供（Value）→フロー図（web3 token）→事例紹介（Case study）→お問い合わせ（Contact）という明快なストーリー構成でデザイン。',
    experience: '企業・ブランドの一気通貫サポートとして、企画構想・技術支援・法務制約対応のアドバイスまで、通常貨でメーカーに伴走。花咲山どぶろく（Japan Web3 Week限定Exchange Ticket NFT / Digital Ambassador NFT）、米鶴酒造（SAKEXとの共創事例）のリアルな事例をケーススタディとして展開。NFTはどぶろく 花咲山と引き換えをする、もしくは移転することができる仕組みを実装。',
    output: 'Service Concept / Web Design / Token Architecture / Brand Strategy / Case Study / Flowchart / Communication',
    impact: 'Made in Japan ブランドのグローバルリーチ拡大。生産者と消費者の直接的な関係構築を実現。二次流通の活性化・ブランド真正性の担保・ファンエンゲージメントの継続という三位一体の価値を提供。花咲山どぶろくを起点に、NFT × 日本の地域産品ブランディングの先進事例を確立。',
    images: [
      {
        src: '/assets/migrated/a404d9b646169c8ab95d.webp',
        caption: 'GLOBAL REACH WITH TOKENS — 事業企画表紙 / トークン ブランディング 戦略',
      },
      {
        src: '/assets/migrated/b375c05adeb60fec6146.webp',
        caption: 'HANASAKIYAMA DOBUROKU. 2024 / DIGITAL AMBASSADOR — スマホでのNFT体験',
      },
      {
        src: '/assets/migrated/1ad3448dbcaa0c94641c.webp',
        caption: 'HANASAKIYAMA DOBUROKU / チケット招待券 & NFT証明 — Japan Web3 Week Limited Exchange Ticket',
      },
      {
        src: '/assets/migrated/5de0569166e6a82e3a4b.webp',
        caption: 'HANASAKIYAMA Doburoku. Japan Web3 Week LIMITED EXCHANGE TICKET — NFTデザイン',
      },
      {
        src: '/assets/migrated/f97ffd96e3a1009903ad.webp',
        caption: 'Service Overview — トークン活用型ブランディング支援サービス / Value 01・02・03',
      },
      {
        src: '/assets/migrated/49aabfb3fc20bdac13fc.webp',
        caption: 'ウェブサイトデザイン全体像 — Issues / Solutions / web3 token フロー / Case study / Contact',
        large: true,
      },
      {
        src: '/assets/migrated/1cc56c4514df286cae08.webp',
        caption: '4フェーズ詳細 — 企画・製造 / 流通・販売 / 引換・消費・体験 / 消費後・ファン化',
      },
      {
        src: '/assets/migrated/032db0d93697c1be446b.webp',
        caption: 'Web3トークンを活用した新しい流通・購買体験 — メーカーからみたトークン化の価値視点',
      },
      {
        src: '/assets/migrated/45038e06b4bbcb56be93.webp',
        caption: 'トークンを活用した新しい流通小売の購買体験による販売戦略の実現 / ブランディング戦略',
      },
      {
        src: '/assets/migrated/527626c8dd94067a53e1.webp',
        caption: '事業企画全体まとめ — GLOBAL REACH WITH TOKENS / Web3フロー / Case study 花咲山・米鶴',
      },
      {
        src: '/assets/migrated/26f298b5983ca2ad79e1.webp',
        caption: 'メーカーからのトークン化戦略 / モノのトークン化による流通の変化 — Real World実在資産からDigital World NFTへのトークン化フロー',
      },
      {
        src: '/assets/migrated/45e01da4df96cf6941b3.webp',
        caption: 'HANASAKIYAMA DOBUROKU FAN証明 / Digital Ambassador — 花咲山どぶろくのファン証明NFTデザイン',
      },
      {
        src: '/assets/migrated/f3b0ebf154cb5b92f75d.webp',
        caption: 'トークン活用型ブランディング支援サービス / Value 01・02・03 — モノのトークン化による新しい物流・継続的関係構築・体験設計',
      },
      {
        src: '/assets/migrated/ff0a5bcc6329c8e56b02.webp',
        caption: 'ウェブサイトデザイン全体像 / 4フェーズ詳細フロー — Issues・Solutions・web3 token・Case study・Contact',
      },
      {
        src: '/assets/migrated/e8850175c5b637311c98.webp',
        caption: 'トークン ブランディング 戦略 スライド1 — GLOBAL REACH WITH TOKENS 事業企画・サービスコンセプト・価値設計',
      },
      {
        src: '/assets/migrated/a1eb1f66d366b65c6e11.webp',
        caption: 'トークン ブランディング 戦略 スライド2 — WEB3・トークンの世界観・トークンによるブランディング戦略の仕組み・流通の変化',
      },
      {
        src: '/assets/migrated/d742995788f332cc8553.webp',
        caption: 'トークン ブランディング 戦略 スライド3 — トークンを活用した新しい流通・購買体験 / 4フェーズ詳細（企画・製造 / 流通・販売 / 引換・消費・体験 / 消費後・ファン化）',
      },
    ],
    videos: [
      {
        src: '/assets/migrated/3f08ce47e6dd845559ab.mp4',
        caption: 'TOKENS ブランディング戦略 映像',
      },
    ],
  },
  {
    id: 'jtb-web3',
    project: 'JTB × web3 FAN Tourism',
    client: 'JTB',
    year: '2024',
    category: 'Business / Service / Digital',
    role: 'Business Design / Service Design / CX Planning',
    issue: '若年富裕層（30代男性）のインバウンド需要獲得が課題。従来の観光モデルでは、高付加価値な旅行者の心をつかめず、リピート・ファン化が進まなかった。',
    challenge: '三越伊勢丹と組んだ「トランクスタイル」という独自の旅行スタイルを、デジタルネイティブな若年富裕層にどう響かせるか。Web3・NFT・メタバースを観光に組み込む新しいモデルの構築。',
    insight: '若年富裕層は「購入」ではなく「体験・共感・自己実現」を重視。滞在型旅行で「その土地の人と同じモノを買う・食べる・体験する」価値を提供することで、単なる観光客からファンへ変容させられる。',
    strategy: 'Web3技術で「旅の思い出」をデジタル資産化。NFTやメタバースを活用し、旅行後も地域との接続を持続させるファンツーリズムモデルを構想。',
    experience: '旅の前後のデジタル体験、地域との接点、ファンとしての継続的な関与を設計。滞在型旅行の体験価値をWeb3で拡張。',
    output: 'FAN Tourism Model / Web3 Platform / NFT Experience / Metaverse Content / Communication Strategy',
    impact: '若年富裕層の獲得と、観光とファン活動を接続する新しい価値モデルの確立。',
    images: [
      { src: '/assets/migrated/db1d1d1a3b0cc4f2060b.png', caption: 'Hero Visual — JTB × web3 FAN Tourism Concept' },
      { src: '/assets/migrated/1f60527cbecbb0ec077b.png', caption: 'Service Concept Overview' },
      { src: '/assets/migrated/4140feb8ecdeb8619723.png', caption: 'Fan Tourism Model Design' },
      { src: '/assets/migrated/3eedfe0af6f7684340a2.png', caption: 'Digital Platform Architecture' },
      { src: '/assets/migrated/ecfc9b9a72c39f056086.png', caption: 'Web3 Integration Design' },
      { src: '/assets/migrated/79209eb6dcaff5458fe2.png', caption: 'CX Journey Map' },
      { src: '/assets/migrated/9c6e3f1807024bb3d676.png', caption: 'Community / Fan Engagement Design' },
      { src: '/assets/migrated/9de0441ff2a56d1f27fb.png', caption: 'NFT / Token Tourism Model' },
      { src: '/assets/migrated/6bf579aef6e257c005e5.png', caption: 'Travel × Web3 Service Design' },
      {
        src: '/assets/migrated/30cd07d84c1c19b2ea0e.webp',
        caption: 'FAN Tourism モデル全体像',
      },
      {
        src: '/assets/migrated/32efd52728fb9d2f0836.webp',
        caption: '結論まとめ・PLAN方向性 page 38 — 自分適正消費（コスパと価値の追求）',
      },
      {
        src: '/assets/migrated/d0ed29d542a2c1cdf75f.webp',
        caption: '若年富裕層・消費動向インサイト分析 — モノコト志向性値と消費決定マインド値A',
      },
      {
        src: '/assets/migrated/d89bd7b587366ef3f2ee.webp',
        caption: 'The New JTB X web3 Branding Plan Vol.2 — フルーツ推し旅・NFT証明・企画戦略',
      },
      {
        src: '/assets/migrated/a41773f537b2b01aa09f.webp',
        caption: '結論まとめ・PLAN方向性 — FAN Tourism JTB × web3 推し旅マトリクス',
      },
      {
        src: '/assets/migrated/fbe41707bb6c68ac4c6d.webp',
        caption: '推し旅・FANツーリズム 解析 page 42 — 4体験軸マトリクス（エステティクス・リトリート・イマーシブ・ディスカバリー）',
      },
      {
        src: '/assets/migrated/994ac3b2b8d543d4d35d.webp',
        caption: 'リサーチ分析の結論 — NEW Luxury・消費決定マインド・自己基準値',
      },
      {
        src: '/assets/migrated/c2889f020ab1f7f994da.webp',
        caption: '若年富裕層・消費動向インサイト分析 — 消費決定マインドB・自己基準値',
      },
      {
        src: '/assets/migrated/5c5da99168b36a57c048.webp',
        caption: 'NFT証明を集めてコミュニティプラットフォームを作成 page 70 — 若年富裕層のクローズドな旅コミュニティ',
      },
      {
        src: '/assets/migrated/b2f9dec94c67a40aa978.webp',
        caption: 'The New JTB X web3 Branding・旅のプラン体験設計 — ペットと共に旅する推し旅・FRUIT SHARING',
      },
      {
        src: '/assets/migrated/c0f67a7a021353ff14b4.webp',
        caption: 'The New JTB X web3 Branding・旅のプラン体験設計 — 推し犬リトリート旅・A Plan/B Plan',
      },
      {
        src: '/assets/migrated/ffdd3d3bb2d438242118.webp',
        caption: '東京芸大アートDX・推し旅企画 pages 84-87 — 旅の舞台になるエリアでアート体験・NFT証明',
      },
      {
        src: '/assets/migrated/bd974fabd32733aee57e.webp',
        caption: 'The New JTB X web3. Branding・FAN Tourism 概念図 — 4体験軸循環マップ（Aesthetics・Retreat・Immersive・Discovery）',
      },
      {
        src: '/assets/migrated/8cbb1a2ac24943d1dbbe.webp',
        caption: 'The New JTB X web3 Branding・旅のプラン 体験設計 pages 76-79 — ハイブランド・カスタムオーダー推し旅・エステティクス体験',
      },
      {
        src: '/assets/migrated/698c1560716b2801c815.webp',
        caption: '若年富裕層が求める動機分析の結論 page 24 — 推し旅の「共体験者・ナラティブ」',
      },
      {
        src: '/assets/migrated/1a50c70a1300665a2c74.webp',
        caption: 'リサーチ分析の結論 page 18 — A.求めてる本質・B.求めてる場所・C.得られる感動',
      },
      {
        src: '/assets/migrated/727fab6930fda132f382.webp',
        caption: 'リサーチ分析の結論 page 17 — A.求めてる本質・B.求めてる場所・C.得られる感動',
      },
      {
        src: '/assets/migrated/10fab986b10886d47813.webp',
        caption: '推し旅・JTB FANツーリズム MAP — 4体験軸（Aesthetics・Retreat・Immersive・Discovery）',
      },
      {
        src: '/assets/migrated/8c9359ca22d62cec35ac.webp',
        caption: '推し旅・得られる「推し価値」page 43 — 4体験軸詳細マップ（美意識・真理・娯楽・発見の追求）',
      },
      {
        src: '/assets/migrated/7251661cdaa08b69361f.webp',
        caption: 'The New JTB X web3 Branding Plan 表紙 page 49 — 4章限コンテンツのうち3つの推し旅プランを企画提案',
      },
      {
        src: '/assets/migrated/2cfbe1904476f3b3c9b3.webp',
        caption: '結論まとめ・PLAN方向性 page 39 — 他社推し旅プラン比較とJTBの強み',
      },
      {
        src: '/assets/migrated/4140feb8ecdeb8619723.png',
        caption: '推し旅・JTB FANツーリズム 企画戦略ロゴマーク — The NEW JTB FAN Tourism（円形枠版）',
      },
      {
        src: '/assets/migrated/6632b4b1a1f4f9e568dd.webp',
        caption: '再掲 The New JTB X web3 Branding・旅のプラン 体験設計 page 88 — FANツーリズム4象限の推し旅でインセンティブ',
      },
    ],
  },
  fujitsuRecruitCase,
  sompoHimawariCase,
  {
    id: 'sb-cs',
    project: 'SB C&S',
    client: 'SB C&S',
    year: 'Archive',
    category: 'Recruitment Branding / Web',
    role: 'Brand Strategy / Web / Communication',
    issue: '卸売・流通事業の採用情報が、事業の面白さを伝えきれていなかった。',
    challenge: 'B2Bの流通事業を、候補者にとって魅力的なキャリアの場として伝えること。',
    insight: '流通の「現場の広がり」こそが、キャリアの多様性として候補者に響く。',
    strategy: '事業領域の多様性を軸に、成長とやりがいを伝える採用ブランドを構築。',
    experience: '職種・事業紹介、キャリアの物語、応募導線まで一貫した体験を設計。',
    output: 'Brand Concept / Web / Content / Communication',
    impact: '事業の魅力を候補者に伝え、採用ブランドを強化。',
    images: [
      {
        src: '/assets/migrated/940dabe1c58856e588d6.webp',
        caption: 'SB C&S Brand Visual — 都市のスカイラインとロゴ',
      },
      {
        src: '/assets/migrated/25b27514cad85179f8d0.webp',
        caption: '採用サイトデザイン方向案 — A/B/C方向案の比較提案',
      },
      {
        src: '/assets/migrated/c3ded1d1c7ce9fd362b8.webp',
        caption: 'SB C&S 新サイトマップ — 採用サイト情報構成設計',
      },
      {
        src: '/assets/migrated/e33077b61b00a9714f5f.webp',
        caption: '採用サイトTOPページデザイン — メインビジュアルとサイト構成',
      },
      {
        src: '/assets/migrated/ddfb64cb5018661526db.webp',
        caption: 'FAN層拡大コミュニケーション設計 — 新卒学生とキャリアユーザーの動向分析',
      },
      {
        src: '/assets/migrated/13bd0313e49a5833a6e1.webp',
        caption: '就活生インサイト分析 — 志向性と動機形成の分析と検証',
      },
      {
        src: '/assets/migrated/3fc60678b5fbcfa7e3e5.webp',
        caption: 'ユーザーボイスPOINTキーワード抽出 — マインドMAP分析・SWOTからターゲットアプローチ分析',
      },
      {
        src: '/assets/migrated/6ee8d9d0bec259d73033.webp',
        caption: 'プログラムツリー展開 — 新採用サイト設計への3つの採用アウトラインと4つの実現可能なフィールド',
      },
      {
        src: '/assets/migrated/9325f2ccfcc7f0ca7c8c.webp',
        caption: 'A方向案 新採用サイトメインコピー案 — ビジュアルデザイン案',
      },
      {
        src: '/assets/migrated/04aef7a459ea6c3e888f.webp',
        caption: 'A方向案 サブコピーとビジュアル構成 — 「限界突破できる場所」',
      },
      {
        src: '/assets/migrated/5dabe0fd11bc0c29dfef.webp',
        caption: 'A方向案 採用サイト全体レイアウト — 新卒・中途採用のコントンツ構成',
      },
      {
        src: '/assets/migrated/c02fdc0b17288a395223.webp',
        caption: 'A方向案 キャッチポイント設計 — 4段階の視認性導線とコンテンツ構成',
      },
      {
        src: '/assets/migrated/1ab1db3083ffb790f981.webp',
        caption: '新採用サイト設計 構築・CMSの導入化 — SP化・CMS導入・ユーザーサ線',
      },
      {
        src: '/assets/migrated/bbbf5bfcd13b228b17b6.webp',
        caption: '新しいコンテンツも導入できる 新採用サイト設計へ向けて — SB C&Sロゴと指を指す手',
      },
      {
        src: '/assets/migrated/50f93371e6785c814eba.webp',
        caption: '新採用サイト TOP グローバルメニュー 構成表示 — プルダウン式メニュー設計',
      },
      {
        src: '/assets/migrated/11303f14b09b54d5b3c1.webp',
        caption: '新採用サイト サイトマップ 一覧表 — SB C&S 新サイトマップ構成',
      },
      {
        src: '/assets/migrated/568bf46ea52a782bbf21.webp',
        caption: '採用ブランディングも視野に入れる 各採用ツールの設計構築 — 採用活動ワンストップ施策サポート',
      },
      {
        src: '/assets/migrated/77e3ec268a6eebc42f00.webp',
        caption: 'SB C&S ブランドビジュアル — ロゴと指を指す手（複数）',
      },
    ],
  },
  hitachiSolutionsCase,
  hitachiSocialCase,
  {
    id: 'ctc-system',
    project: 'CTC System Management',
    client: 'CTC',
    year: 'Archive',
    category: 'Web / UX/UI / Recruitment',
    role: 'Brand Strategy / Web / UX/UI',
    issue: 'システム運用・管理の仕事が、候補者に専門的でイメージしにくいものとして捉えられていた。',
    challenge: 'システム運用を、社会の安心を支える価値ある仕事として伝えること。',
    insight: '「AIに関わるエンジニアをターゲットに」「RPA」「MAKE」——「社会の裏側を支える」という誇りと、新しい技術に触れられる成長環境が両方伝わると魅力が増す。',
    strategy: 'AI・RPAなど新技術に関わるエンジニアをターゲットに、インターンシップ説明会の日時をファーストビューに持ってくるLP構成で、運用・管理業務の社会的価値と成長機会を軸にした採用体験を設計。',
    experience: '業務の見える化、エンジニアの物語、応募導線まで一貫した体験を構築。',
    output: 'Brand Concept / Web / UX/UI / Content',
    impact: '仕事の価値理解を深め、採用ブランドを強化。',
    images: [
      { src: '/assets/migrated/51d84595dff6c9fa729e.png', caption: 'Hero Visual — CTC System Management Brand Overview' },
      {
        src: '/assets/migrated/3a65906594ae6e4b8659.webp',
        caption: 'WEB採用サイト ツールデザイン実績 — CTCシステムマネジメント インターンシップ用LP「RPA MAKE」デジタル映像動画ツール / PC・スマートフォン版展開',
      },
      {
        src: '/assets/migrated/fa30cf35fbf76f7b89f1.webp',
        caption: 'WEB採用サイト ツールデザイン実績 — 富士通ネットワークソリューションズ IDカード・QRコード・クリアファイル・リーフレット「Link It All.」リアルツール 認知ツール',
      },
      {
        src: '/assets/migrated/c01fd34ca818b50d65d9.webp',
        caption: 'WEB採用サイト ツールデザイン実績 — 東芝三菱電機産業システム (TMEiC) 採用パンフレット 12P リアルツール 理解ツール — We drive industry / リクルートメントガイド（誌面）・社員インタビュー',
      },
      {
        src: '/assets/migrated/d8968b64eb54fb8c39ca.webp',
        caption: 'WEB採用サイト ツールデザイン実績 — 富士通株式会社 タブロイド 8P 「FUJITSU CAREER vol.01 数字とキーワードで知る富士通」 A〜Zのキーワード構成 / 社長メッセージ・言葉さがし / リアルツール 認知・理解ツール',
      },
      {
        src: '/assets/migrated/893ffe9db200276f866b.webp',
        caption: 'WEB採用サイト ツールデザイン実績 — インフォテック株式会社 採用動画制作「その一歩に挑む。」デジタル 映像動画ツール 理解ツール — 社員インタビュー 採用メッセージ動画 / アニメーションによる会社概要説明 / 金融第1統括部 千葉 大介',
      },
      {
        src: '/assets/migrated/097143f1da72cd53b1b6.webp',
        caption: 'WEB採用サイト ツールデザイン実績 — 富士通株式会社 キャリア採用サイト 「現代を担い、次代を創造する FUJITSU CAREER」 デジタル WEBツール 理解・行動ツール — 社員インタビュー・求人リスト・キャリアパス全ページ構成',
      },
      {
        src: '/assets/migrated/574462c60c80c2bfb6cb.webp',
        caption: 'WEB採用サイト ツールデザイン実績 — 富士通ネットワークソリューションズ 「Link It All.」 2020年採用サイト ワンストップソリューション ツール 理解・行動ツール — バラまきツールに誘導・IDカード・リーフレット・ランディングページ・採用サイトのワンストップ展開',
      },
    ],
  },
  {
    id: 'nisshin-wanokiwami',
    project: 'Nisshin Petfood — JP STYLE',
    client: '日清ペットフード',
    year: '2015',
    category: 'Experience / Spatial / Event',
    role: 'Brand Experience / Spatial / Event Design / Promotion',
    issue: 'ペットフードの展示会出展が商品棚の中だけで完結し、来場者との深い接点が不足していた。競合ブースとの差別化と、商品理解を超えたブランド共感が必要だった。',
    challenge: '「和の究極」というブランド世界観を、来場者が五感で体感できるイベント空間に具象化すること。展示会場での回遊性と滞在時間の向上。',
    insight: 'ペットオーナーは「安全・安心・健康」だけでなく、「あじわい」という感情価値も重視する。「和の究極」＝Triple-Engage（安全安心・健康・あじわい）で来場者の心に届く。',
    strategy: '2015年「ペット博」（東京ビッグサイト）に出展。「和の究極」をコンセプトにしたイベント空間を設計。試食会・撮影会を実施し、来場者の回遊と商品理解を促進。和の素材を活かした空間演出で差別化。',
    experience: '展示会ブース、試食体験、撮影会、ノベルティ配布、来場者導線を通じた統合プロモーション。',
    output: 'Event Space / Booth Design / Trial Event / Photography / Promotion / Spatial',
    impact: '前年比大幅増の来場者数。日清ペットフード様来場者数が前年2%→14%に向上（全体来場者数に占める割合）。商品理解とブランド共感の深化。',
    images: [
      { src: '/assets/migrated/3f07bfdc8f78ead8dbed.png', caption: 'Hero Visual — Nisshin Petfood JP STYLE Event' },

      {
        src: '/assets/migrated/cab56bdab5028b1c5c72.webp',
        caption: '実際のブース写真 — ペット博会場での賑やかな来場者の様子',
      },
      {
        src: '/assets/migrated/916f94a638513f80ea6b.webp',
        caption: '企画書 — クイズラリーデザイン仕様・運営方法・イベントスケジュール・ブースデザイン総合受付',
      },
      {
        src: '/assets/migrated/8c65196400317c6a4774.webp',
        caption: '企画書 — 展示会ブース2015年出展プラン・3つの取組み・ブースコンセプトTriple-Engage・ブースイメージ',
      },
      {
        src: '/assets/migrated/e85f65aeff3499e1c8fe.webp',
        caption: '企画書 — 展示会・イベント施策・造作デザイン（コンテンツの充実とその運営計画・導線計画・造作デザイン）',
      },
      {
        src: '/assets/migrated/fa8b89bfe785195d55a5.webp',
        caption: '企画書 — 全体スケジュール・運営体制図・スタッフ配置図・イベント実施報告写真',
      },
      {
        src: '/assets/migrated/a3ae55eac3c6749c1e7f.webp',
        caption: 'イベント実施報告写真 — 実施報告写真 page 70・71（会場の賑わい・ブース全体像）',
      },
      {
        src: '/assets/migrated/71923086e92c8e471d06.webp',
        caption: '企画書 — ブースコンセプト・ブースイメージ・ブースゾーニング図・イベント実施報告写真',
      },
      {
        src: '/assets/migrated/87e5b1b7134446c5c08a.webp',
        caption: '実際のブース写真（別アングル） — JP STYLE「和の究み」ピラーと「おいしさ」エリア',
      },
      {
        src: '/assets/migrated/21174b7fd9b88b95f742.webp',
        caption: '企画書 — 前年度と今年度の比較・イベント結果報告（来場者数14% UP・前年比7倍）',
      },
      {
        src: '/assets/migrated/7c7232557d3da10cf896.webp',
        caption: 'ブースCGパース — 3Dレンダリング（赤と白のJP STYLEブース全体像）',
      },
      {
        src: '/assets/migrated/d0227c05ab724cf355ba.webp',
        caption: '実施報告写真 page 68/69 — 会場の賑わい・ブース全体像・ピラー・プリントシール撮影会',
      },
      {
        src: '/assets/migrated/65a824529dfb6256106c.webp',
        caption: 'ブース実写写真 — JP STYLE「和の究み」ピラーと受付・物販エリア',
      },
      {
        src: '/assets/migrated/5745b5de438c04adbb51.webp',
        caption: '企画書 — 3つの取組み（安全安心・健康・おいしさ）・ブースゾーニング図・クイズラリー仕組み',
      },
      {
        src: '/assets/migrated/9a327ace70445550f8ea.webp',
        caption: '企画書 — イベント結果報告（来場者数14% UP・前年比7倍）・次回に向けて',
      },
      {
        src: '/assets/migrated/b51a0e7f888e083f7e81.webp',
        caption: '企画書 — イベント実施報告写真 page 35/37（会場の賑わい・ブース全体像）',
      },
      {
        src: '/assets/migrated/ec5ca0972d890c42e471.webp',
        caption: '企画書 — 実施報告写真 page 66/67（会場案内・ブース全体像・各エリア写真）',
      },
      {
        src: '/assets/migrated/9d61221d1040363c1db6.webp',
        caption: '企画書 — 展示会・イベント施策・造作デザイン（全体図・パネル造作・実写写真）',
      },
      {
        src: '/assets/migrated/7e806ddcfd12228d10d9.webp',
        caption: 'ブース実写写真 — 「懐石」「おいしさへの取組み」ピラーとプリントシール撮影会',
      },
    ],
  },
  {
    id: 'nisshin-seven-musubi',
    project: 'Nisshin Petfood — Seven Musubi',
    client: '日清ペットフード',
    year: '2016',
    category: 'Experience / Spatial / Event',
    role: 'Brand Experience / Spatial / Event Design / Promotion',
    issue: 'ペットフードブランドの認知拡大と、新商品の理解を促進する体験が不足。大型連休中の集客と、競合イベントとの差別化が課題だった。',
    challenge: 'ゴールデンウィークの大型連休中に来場者を集客し、新商品の認知と理解を深めること。待機列の発生など、体験の質を担保しながらの運営。',
    insight: '七福ペットたちが、商品と来場者との"結び"を生み出すために、縁起の良い宝船に乗ってやってきた。その親しみやすいモチーフである宝船が、和の世界観を空間全体に広げ、来場者と商品の新しい出会いを演出する。',
    strategy: '2016年「七彩祭（seven musubi）」を開催。宝船をモチーフにした円型商品陳列で回遊性を高め、試食会と抽選会で参加体験を設計。和の世界観を統一した空間演出。',
    experience: '宝船ディスプレイ、試食会、抽選会、撮影会、SNS投稿促進を通じたブランド体験。',
    output: 'Event Design / Spatial / Trial / Promotion / Photography / Display',
    impact: '4日間で63,208人来場（前年比31.6%増）。商品理解促進と集客率向上を実現。試食・抽選による体験型接点でブランド共感を創出。',
    images: [
      { src: '/assets/migrated/1c551e0a6c557bb8ce68.png', caption: 'Hero Visual — Nisshin Petfood Seven Musubi Event' },
      {
        src: '/assets/migrated/33fd68d8de89852c6192.webp',
        caption: '企画書 — イベント全体運営・全体の構成・全体【結果】「七彩祭」ブース来場者数向上（商品認知度促進・集客率向上）',
      },
      {
        src: '/assets/migrated/c845d98ffb016a4aada1.webp',
        caption: '企画書 — 造作物デザインコンセプト・デザインコンセプト企画・七彩祭「seven_musubi」コミュニケーションコンセプト・ゾーニング図',
      },
      {
        src: '/assets/migrated/25fc9198221ef5465d18.webp',
        caption: '企画書 — クイズスタンプラリー デザイン詳細図・イベント全体運営（総括・立面図・造作図）・2016年度 造作物デザインと現場での改善点',
      },
      {
        src: '/assets/migrated/ae2329ef579f3773d4d9.webp',
        caption: '企画書 — 造作物デザインコンセプト（七彩祭 seven_musubi）・イベント全体運営総括・ブース立面図・宝船造作図',
      },
      {
        src: '/assets/migrated/526db8781680a323dc75.webp',
        caption: 'ブース実写写真 — JP STYLE「和の究み」展示会ブース実写（宝船・懐石・いぬのしあわせ・ゴロっと具ルメ 各陳列エリア）',
      },
      {
        src: '/assets/migrated/cdd10fc4b3aea22b84bd.webp',
        caption: '企画書 — セルフ撮影コーナー・試食会 運営フロー / インターペット 会場 スタッフポジション図',
      },
      {
        src: '/assets/migrated/missing-transparent.gif',
        caption: 'ブースCGパース — 2016年度 七彩祭 JP STYLE「和の究み」ブース 3Dレンダリング（全体外観・バルーン・宝船）',
      },
      {
        src: '/assets/migrated/7fb8d46f4c6a46d6d88e.webp',
        caption: '企画書 — 2016年度 造作物デザイン立面図・クイズスタンプラリー詳細図（完成版・スタンプなし・裏面）・スタンプデザイン',
      },
      {
        src: '/assets/migrated/feecca4855093792708e.webp',
        caption: '企画書 — 運営フロー：クイズスタンプラリー（台紙配布〜スタンプ収集〜ノベルティ配布）/ 運営フロー：抽選会（ハズレ無し！大抽選会・シミュレーション）',
      },
      {
        src: '/assets/migrated/5257feac2170e532acdc.webp',
        caption: '展示会パネルデザイン — 懐石・LIFE 20 安全安心・国産プレミアムフード・JP STYLE 和の究み / ねこ福・いぬのしあわせ ゴロっと具ルメ 商品パネル4枚',
      },
      {
        src: '/assets/migrated/19ed8f27694722e94d4e.webp',
        caption: 'ブース実写 — 懐石・日清ペットフード商品陳列（カラフルパッケージ・七福キャラクター）',
      },
      {
        src: '/assets/migrated/53552170fe7f059643d3.webp',
        caption: '七彩祭 seven_musubi キービジュアル — 宝船・和の究み・七福キャラクター（縦書きコピー付き）',
      },
      {
        src: '/assets/migrated/e1f6e5c88268a60c7406.webp',
        caption: '七彩祭 seven_musubi キービジュアル — 日清ペットフード株式会社版（ロゴ・宝船・七福キャラクター）',
      },
      {
        src: '/assets/migrated/1a6627ba877d55fb7aed.webp',
        caption: 'ブース実写 — 懐石コーナー商品陳列と「和の究み」「LIFE 20」パネル',
      },
      {
        src: '/assets/migrated/72213f13d867fcda20ce.webp',
        caption: '企画書 — 展示会・イベント施策・運営と結果報告書（SNS施策・FOTOfwd縁結び撮影会・宝船・全体結果）',
      },
      {
        src: '/assets/migrated/ed6f3fe66a8a24305391.webp',
        caption: '店頭展開実写 — ブランド訴求を機能軸で展開（JP STYLE商品陳列・ディバイダーツール・スイングツール・商品チャート表）',
      },
      {
        src: '/assets/migrated/e09afb61b99dc7de18a0.webp',
        caption: '企画書 — 展示会・イベント施策・運営と結果報告書（縁・結び・集めた・力・宝船・全体結果）',
      },
      {
        src: '/assets/migrated/757f0789323daee95279.webp',
        caption: '企画書 — 展示会・イベント施策・PDCA連携（イベントからリアル店舗・ECへ誘導）・競合フードポジショニングMAP・JP STYLE和の究みシリーズ商品ラインナップ・LIFE20国産',
      },
      {
        src: '/assets/migrated/6a8d59758707f4d94a78.webp',
        caption: 'ブース実写＋CGパース マルチパネル — 懐石コーナー商品陳列・いぬのしあわせエリア・宝船ディスプレイ・七福キャラクター・抽選会景品告知',
      },
      {
        src: '/assets/migrated/b2929f9b51a570546d7c.webp',
        caption: 'ブース実写4分割 — いぬのしあわせエリア・懐石コーナー・七福キャラクター商品陳列・JP STYLEブース全体',
      },
      {
        src: '/assets/migrated/f977c2aedf2d80d97085.webp',
        caption: 'ブース全体実写 — 「いぬのしあわせ」エリア・懐石コーナー・JP STYLE ピラー・会場全景',
      },
    ],
  },
  {
    id: 'tokyo-gas-eco',
    project: 'Tokyo Gas ECO PRODUCTS 2014',
    client: 'Tokyo Gas',
    year: '2014',
    category: 'Experience / Spatial / Education',
    role: 'Experience Design / Spatial / Education / Exhibition / Display',
    issue: 'エネルギー商品・エコプロダクトの技術的価値が、生活者の暮らしの中での実感として伝わりにくい。家庭で使うガスやENE-FARMなどの先端技術を、子どもから大人まで楽しく理解できる仕組みが必要だった。',
    challenge: '技術的な説明を超え、五感で体感できる教育型イベント空間を設計すること。ECO PRODUCTS 2013から2014へ進化させ、来場者の理解と共感を深める。',
    insight: '「ボールガス」などで子どもが遊びながら仕組みを理解できる体験と、Step展示による段階的な学びが、環境価値を実感へと変える。家庭の中で使うエネルギーを身近に感じさせることが鍵。',
    strategy: 'ECO PRODUCTS 2014で、Step1〜Step5の展示構成で家庭内エネルギーの流れを可視化。ENE-FARMを中心に、子ども向け体験コーナー（ボールガス）と連動させた教育型イベント設計。エレベーション什器とDIC指定カラー（DIC-157・DIC-222・DIC-5461/2）による統一されたブランド空間を構築。',
    experience: '展示パネル、エレベーション什器、体験コーナー、配線・展示什器の設計、DIC指定カラーを活かした統一した空間演出。2013年との進化も展示。',
    output: 'Exhibition Design / Spatial / Education / Elevation / Display Structure / Color Planning / Communication',
    impact: '環境価値の体験的伝達と、東京ガスブランドへの親しみと理解の深化。子どもから大人まで楽しく学べる展示として評価。',
    images: [
      {
        src: '/assets/migrated/5e096c936da4ca8a1fd9.webp',
        caption: 'ECO PRODUCTS 2014 東京ガスブース — 鳥瞰展示場の展示構成とご来場者の様子',
      },
      {
        src: '/assets/migrated/f5e01eb03992bba006a3.webp',
        caption: 'ブース実写集合写真 — ECO PRODUCTS 2014 スタッフ全員集合・ブース実写・CGパース鳥瞰図・東京ガス ENE-FARM',
      },
      {
        src: '/assets/migrated/ffaa3939d1ae079b5a6d.webp',
        caption: 'ELEVATION-1 / STEP-1 パネルデザイン — S=1:15 A展開・I展開（DIC色指定 アーバンブルー・ライブレッド・Poplar Std Black）',
      },
      {
        src: '/assets/migrated/0042269e1b48e023019b.webp',
        caption: 'イベント実写4枚 — 東京ガスブース来場者の様子・エコプロダクツ2014会場・「どんなエネルギー？」パネル前の来場者',
      },
      {
        src: '/assets/migrated/b800360f05459c460f09.webp',
        caption: 'イベント実写9分割 — スマートエネルギーネットワークブース・コンパニオン・来場者対応・エコプロダクツ2014 会場風景',
      },
      {
        src: '/assets/migrated/57dc37f43531c76d32c5.webp',
        caption: 'ECO PRODUCTS・イベント施策 / デザイン設計 — コンセプト・ブース平面図・ELEVATION-2 STEP-3 C展開・ELEVATION-1 STEP-1 A展開',
      },
      {
        src: '/assets/migrated/9324166fdb8c663e517f.webp',
        caption: 'ELEVATION-3 / STEP-4 D展開 — 「ガスコージェネレーションシステムはまちの中でどう使われているの？」立面図 S=1:15（w4780）',
      },
      {
        src: '/assets/migrated/32bca2c4b62850131d49.webp',
        caption: 'ECO PRODUCTS・イベント施策 / ギミック詳細設計図 — STEP-5 スマエネシティギミック・STEP-4 D展開・家型カルプ・ボックス部分詳細図・TOKYO GAS サイン詳細',
      },
      {
        src: '/assets/migrated/6be8b660a5ed18c2a405.webp',
        caption: 'STEP-5 詳細図面 — スマートエネルギーネットワーク PLAN図・街路詳細・A-A断面・B-B断面（TOKYO GAS サイン詳細）',
      },
      {
        src: '/assets/migrated/22e352a0f10d18e51ef1.webp',
        caption: 'ECO PRODUCTS・イベント施策 / 会場記録 — 「イベントは連日大盛況！」東京ガス ECO PRODUCTS 2014 記録 会場写真6枚',
      },
      {
        src: '/assets/migrated/9a85204a30d5dea18dad.webp',
        caption: 'ブース平面図 PLAN図 — STEP_1〜5配置・A-A/B-B/C-C断面・メイン導線',
      },
      {
        src: '/assets/migrated/35c2a5780bca59d74f9d.webp',
        caption: 'ECO PRODUCTS 2014 イベントコンテンツプラン — ブース実写6枚 + STEP 2/3/4パネルデザイン',
      },
      {
        src: '/assets/migrated/0cc4f5097a819e033a8a.webp',
        caption: 'ギミック詳細設計図 — A-A/B-B/C-C断面・オフィスビル断面図・CSグラフィックシート貼り',
      },
      {
        src: '/assets/migrated/d05c8a1e651510b1c44d.webp',
        caption: 'ECO PRODUCTS・イベント施策 / 会場記録 — ブース実写6枚 + スマートエネルギーネットワーク説明',
      },
      {
        src: '/assets/migrated/d8ea952c539a4b559201.webp',
        caption: 'イベント実写4分割パネル — エコプロダクツ2014会場・「どんなエネルギー？」パネル・エコプロダクツロゴ',
      },
      {
        src: '/assets/migrated/75b059d531aa1387bd31.webp',
        caption: 'TOKYO GAS ECO PRODUCTS 2014 記録会場写真 — ブース実写4枚 + CGパース鳥瞰図',
      },
      {
        src: '/assets/migrated/3dc2393cc830f2fd8637.webp',
        caption: 'ELEVATION-2 / STEP-3 C展開 — 「エネファームのある暮らし」・ガスコージェネレーションシステム',
      },
    ],
  },
  jmilkDieteticCase,
  {
    id: 'baby-me-event',
    project: 'BABY&Me BELK. Event',
    client: 'BABY&Me',
    year: 'Archive',
    category: 'Event / Brand Experience',
    role: 'Event Design / Brand Experience',
    issue: 'ブランドの価値が商品体験に留まり、親子の絆を体感する場が不足していた。',
    challenge: '「抱っこ」の豊かさを、親子が実際に体験できる場として表現すること。',
    insight: '「ずっと使える」「真似できない楽さ」「ワンランク上の使い心地」——ヒップシートキャリア「BELK.」はお子様の成長に合わせて最も長くご使用いただけるシリーズ。「抱っこの時間」こそが、親子のコミュニケーションとして最も強く伝わる。',
    strategy: '「ずっと使える、真似できない楽さ」をイベントコンセプトに、BABY&Meの新ヒップシートキャリア「BELK.」の体験イベントを設計。2021年度グッドデザイン賞受賞の価値を、親子が参加して体感できるイベント体験として展開。',
    experience: 'イベント・体験コンテンツを通じて、ブランドの価値を実感できる場を構築。',
    output: 'Event Design / Experience / Brand Communication',
    impact: 'ブランド価値の体験的伝達と、参加者との関係構築を実現。',
    images: [
      { src: '/assets/migrated/aa3dee3d203d486fef81.jpg', caption: 'Hero Visual — Event Overview' },
      { src: '/assets/migrated/e0c5ff67b40f156a8266.webp', caption: 'Event Concept / Brand Design' },
      { src: '/assets/migrated/f4b490a0f0161dbdf77f.webp', caption: 'EXPOブース内観 — ワイドショット・トーテムディスプレイ・商材展示' },
      { src: '/assets/migrated/97fd211d59a0a0ce01da.webp', caption: 'BELK. ライフスタイル — NEW!! BABY&Me BELK. 使用シーンコラージュ' },
      { src: '/assets/migrated/1ed341c0346ae78d2eb9.webp', caption: 'BELK. ブランディング事例 — GOOD DESIGN AWARD 2021・KIDS DESIGN AWARD 2021 受賞' },
      { src: '/assets/migrated/8e4607f04ff91a325921.png', caption: 'Visual Identity / Communication' },
      { src: '/assets/migrated/b485f2cf926880699a14.png', caption: 'Event Materials / Promotion Tools' },
      { src: '/assets/migrated/2477f7839df7696138f1.png', caption: 'Spatial Design / Experience' },
      { src: '/assets/migrated/941a5bf6732ae2ea4bf8.png', caption: 'Brand Story / Communication' },
      { src: '/assets/migrated/881377c8048a2d30f82e.png', caption: 'Product Display / Touchpoint' },
      { src: '/assets/migrated/a295d15bbf765c4ea998.png', caption: 'Event Scene / Atmosphere' },
      { src: '/assets/migrated/8d414ccdba56bf6c636d.png', caption: 'Parent & Baby Experience' },
      { src: '/assets/migrated/7f1bc374a71b9b56de34.jpg', caption: 'Event Photography / Real Scene' },
      { src: '/assets/migrated/84879f19d06137d7afe6.webp', caption: 'サイン&グラフィック — 立面パネル A/C（BABY&Me NEW!! BELK. / 真似できない楽さ）' },
      { src: '/assets/migrated/cc7361eccf3e60533c15.webp', caption: 'EXPOブース実写 — 内観・トーテムディスプレイ・商材展示' },
      { src: '/assets/migrated/eb4eec17024bbf33cd9a.webp', caption: 'EXPOブース実写 — 外観・i-angel/BABY&Me ディスプレイ・トーテム' },
      { src: '/assets/migrated/3090c7cbb172989d8974.webp', caption: 'BELK. NEW!! ショーケース — 商材展示・マネキン・POP' },
    ],
  },
  jwwTisiCase,
  {
    id: 'kinsho-65th',
    project: 'KINSHO 65th Anniversary',
    client: '近商ストア',
    year: '2021',
    category: 'Retail Promotion',
    role: 'Promotion / Retail / Communication / Store Design / Web / SNS',
    issue: '65周年という節目を、単なる周年告知に留めず、地域密着型のお客様との「絆（KIZUNA）」を深める機会にしたい。コロナ禍における消費者の行動停滞に対し、ブランドが寄り添う価値を示す必要があった。',
    challenge: '「65年分の感謝」と「新生活スタイルの応援」を掛け合わせ、現代の顧客に共感を呼ぶメッセージとして伝えること。大型モール群、GMS群、SM群それぞれの商圏特性に応じた施策設計。',
    insight: '2021年の消費者は「無理しない」「新しい価値発見」「家族・家庭の絆」を重視する傾向。これらの意識に応える「新生活の応援」として近商ストアを位置づけると、単なる周年イベントを超えた「共に歩むブランド」としての信頼関係を構築できる。',
    strategy: '「KIZUNA（絆）」をキーコンセプトに、Plan.A「65th大感謝祭」、Plan.B「意識向上・新価値提供」、Plan.C「期待感喚起」の3本柱で展開。店内装飾・演出計画、媒体展開（A4/B2告知チラシ、腰幕、POP）、Web・LINE・SNS連動、月火曜市との施策連動で統合プロモーションを構築。',
    experience: '各店舗（松原店など）の食品コーナー・水産コーナーなどに応じた店内装飾。折込チラシ、LINE配信、SNS施策、公式Webとの連動で来店を促進。参加型施策として「家族の記念日PHOTO」SNS募集、各店長による選考会、景品展開などで顧客エンゲージメントを高める。',
    output: 'Campaign Planning / Store Decoration / Retail Promotion / POP / Poster / Web / SNS / Event',
    impact: '来店顧客との関係深化と、新生活応援としてのブランドポジション確立。地域密着型周年祭としての認知向上。',
    images: [
      { src: '/assets/migrated/5ce792b8bfd67dae4c53.png', caption: 'Hero Visual — KINSHO 65th Anniversary Campaign' },
      { src: '/assets/migrated/0e030d6b78eaa0b0dc3e.webp', caption: 'コミュニケーション設計 — バリュー抽出・計画設計・方向性' },
      { src: '/assets/migrated/bf7daccf4a20fa8aba62.webp', caption: 'キービジュアル展開 — 店舗内外装飾・ロゴ・ハローキティコラボ' },
      { src: '/assets/migrated/bd40ed596910dc809e8f.webp', caption: 'Webリニューアル・施策展開・コンテンツ設計' },
      { src: '/assets/migrated/44bec7d52a5761a4b90c.webp', caption: 'キービジュアルB方向 — デザイン案とチラシ展開' },
      { src: '/assets/migrated/fb6157263cfca9fbbdae.webp', caption: 'ターゲットアプローチとステージポジショニング' },
      { src: '/assets/migrated/45fb6170e138ae99aa16.webp', caption: '65周年 Anniversary VIロゴ' },
      { src: '/assets/migrated/bd70fd1cdcf09c3e4ca3.webp', caption: 'ポスター・店内演出「START!」' },
      { src: '/assets/migrated/f44c60635096d64b801b.webp', caption: 'ハローキティコラボレーション' },
      { src: '/assets/migrated/a8821b36f03d34f2fae6.webp', caption: '店内装飾・演出計画 — 松原店 青果コーナー' },
      {
        src: '/assets/migrated/fd42c64a7bed8cd5ecc4.webp',
        caption: 'ステージポジショニング確認 — KINSHOとHarvesの双方ポジション戦略',
      },
      {
        src: '/assets/migrated/80e4e6888c8752f314c3.webp',
        caption: 'コミュニケーションダイグラム — KIZUNA 3つの絆プロモーション施策',
      },
      {
        src: '/assets/migrated/89bec1a960327ed366a1.webp',
        caption: 'コロナ禍の生活意識調査 — 消費者行動変化と生活スタイル分析',
      },
      {
        src: '/assets/migrated/2d2b393630ab271be8b2.webp',
        caption: '65th Anniversary VIロゴ — りんごモチーフの記念ロゴマーク',
      },
      {
        src: '/assets/migrated/1733131aaa1207dcfc3f.webp',
        caption: 'Hello Kitty × KINSHO 65周年コラボ企画',
      },
      {
        src: '/assets/migrated/66b62ff585892f90c2a4.webp',
        caption: 'VALUE PROJECT. KIZUNA — 消費者意識から導く周年祭企画',
      },
      {
        src: '/assets/migrated/011f2ca6b12c4563fd33.webp',
        caption: 'プロモーションスタートアップ4ヶ月施策案 — チラシ・SNS・フォトスポット',
      },
      {
        src: '/assets/migrated/881319db4b0f9a2e81e0.webp',
        caption: '3PLANステージプロモーションとフロー展開',
      },
      {
        src: '/assets/migrated/72575da0cafcdca78ad8.webp',
        caption: 'コミュニケーションキービジュアル — 店内の展開設置イメージ',
      },
      {
        src: '/assets/migrated/421d265bf6ec46ca565c.webp',
        caption: '店内装飾・演出計画 — 松原店青果コーナー導線プラン B案/C案',
      },
      {
        src: '/assets/migrated/a20cbf6c5896104ece2f.webp',
        caption: 'プロモーション施策 PLAN.C / Webサイトリニューアル案・現状分析',
      },
      {
        src: '/assets/migrated/a1bca21b25b7b2b6a2dc.webp',
        caption: '65th キービジュアル案 ヨコ組 デザインコンセプト — KIZUNA',
      },
      {
        src: '/assets/migrated/98403183b4f0fcb29ff6.webp',
        caption: 'ターゲットアプローチ選定 — 3世代ファミリーターゲット',
      },
      {
        src: '/assets/migrated/ef23e5a4757966d20c14.webp',
        caption: '店内装飾・演出計画 — 松原店冷ケース（水産コーナー）B案/C案',
      },
      {
        src: '/assets/migrated/57320ac9061458b502fd.webp',
        caption: 'コミュニケーションコンセプト・タグライン・消費者の生の声',
      },
      {
        src: '/assets/migrated/130b95422bc95e7f34b2.webp',
        caption: 'Webサイトリニューアル — デジタル施策連動・キャッチアップしやすいWeb設計',
      },
      {
        src: '/assets/migrated/3ab956bfde77ded7274d.webp',
        caption: 'プロモーション施策 PLAN.B / PLAN.C — KIPS連動クーポン・レシピシェア・SNS施策',
      },
      {
        src: '/assets/migrated/0ccea62e6ec2fa0b931f.webp',
        caption: 'A案 周年祭 全媒体ツール — 媒体デザイン/全種媒体一覧表 全12種',
      },
      {
        src: '/assets/migrated/565959a9dbe0158a705d.webp',
        caption: 'Hello Kitty × KINSHO 65周年コラボレーションロゴ',
      },
      {
        src: '/assets/migrated/bc417a4e4f6b84842b36.webp',
        caption: '65周年 周年祭トータルブランディング — 3つの絆 Plan.A/B/C',
      },
      {
        src: '/assets/migrated/85ce19f259065458db32.webp',
        caption: 'プロモーション各拠点施策 — Web・モバイル・デジタルサイネージ連動',
      },
      {
        src: '/assets/migrated/7b6b6bb46aca5488ee23.webp',
        caption: 'コミュニケーションキービジュアル A方向 — デザイン案と展開イメージ',
      },
      {
        src: '/assets/migrated/482fb3fc6dc0ba8b7e1f.webp',
        caption: 'コミュニケーションダイアグラム — 消費者意識と生活気分の価値設計',
      },
      {
        src: '/assets/migrated/499263bb2a66907092ae.webp',
        caption: 'コミュニケーションキービジュアル C方向 — デザイン案と展開イメージ',
      },
      {
        src: '/assets/migrated/ea3c03fbd795182b1739.webp',
        caption: '店舗外プラン/媒体展開イメージ — 新生駒店 店外入口付近 A案',
      },
      {
        src: '/assets/migrated/62d6a0d455c44deebd6d.webp',
        caption: '65周年祭 プロモーション — キービジュアルポスター・「START!」店内演出（KIZUNA いよいよ大感謝祭）',
      },
      {
        src: '/assets/migrated/b89a55eea2f81cc8d28c.webp',
        caption: 'B案 周年祭 全媒体ツール — 媒体デザイン/全種媒体一覧表 全12種（子供キービジュアル）',
      },
      {
        src: '/assets/migrated/988a86ecbcb37ff5fcc4.webp',
        caption: 'C案 周年祭 全媒体ツール — 媒体デザイン/全種媒体一覧表 全12種（野菜キービジュアル）',
      },
      {
        src: '/assets/migrated/b08998e8dc87c1407efc.webp',
        caption: '65th キービジュアル案 タテ組 デザインコンセプト — ティザー広告と通常展開での広告連動・絆を深めていく',
      },
      {
        src: '/assets/migrated/36d56f03969816be023d.webp',
        caption: '65th コミュニケーション ロゴ案 — KINSHO × Harves 周年ロゴ4バリエーション',
      },
    ],
  },
  {
    id: 'transino',
    project: 'TRANSINO',
    client: '第一三共ヘルスケア',
    year: 'Archive',
    category: 'Retail / Trial Promotion',
    role: 'Promotion / Retail / Trial Campaign',
    issue: '高価格帯の美白美容・ヘルスケア商品が、購買のハードルにより試しにくい状況だった。',
    challenge: '「美白、完成。」という商品価値を、生活者にリスクなく「試せる」機会として届けること。',
    insight: '美容・健康商品は「信じて買う」より「試して納得する」方が、継続につながる。「美白、完成。」——メラニンの生成を抑え、しみ・そばかすを防ぐトラネキサム酸配合の医薬部外品ホワイトニングエッセンス。',
    strategy: '「TRANSINO WHITENING ESSENCE NEW」をトライアル軸にした販促で展開。30gのトライアルサイズで美白の完成体験を届け、購買へつなげる導線を構築。',
    experience: '店頭トライアル、サンプリング、プロモーションを通じて、医薬部外品としての信頼感と美白効果の商品体験を提供。',
    output: 'Trial Campaign / Retail / Sampling / Communication',
    impact: 'トライアルから購買への転換と、商品価値の体感を実現。',
    images: [
      { src: '/assets/migrated/71e79b30876a0e1224b1.webp', caption: 'Hero Visual — TRANSINO Whitening Essence NEW' },
      { src: '/assets/migrated/6932b94018af1c09058d.webp', caption: 'Campaign Overview — Trial Promotion' },
      { src: '/assets/migrated/5e86c09b73090b76875e.webp', caption: 'Shelf Display — Retail Environment' },
      { src: '/assets/migrated/823e0dbdf274e64b420d.webp', caption: 'Communication Copy Direction' },
      { src: '/assets/migrated/61a35ab242cae34e7ffa.webp', caption: 'Copy Variations — A/B Testing' },
      { src: '/assets/migrated/4c30a9172408e789e009.webp', caption: 'Problem-Solution Matrix' },
      { src: '/assets/migrated/ea5cc51b9d0e0a7a04b8.webp', caption: 'Store Type Analysis' },
      { src: '/assets/migrated/7773b8a5f0f13907d04e.webp', caption: 'VMD Tool & Jumbo Package' },
      { src: '/assets/migrated/83c9db2b7dc758817a7c.webp', caption: 'Project Title — Daiichi Sankyo Healthcare' },
      { src: '/assets/migrated/0661c0aad2711296410e.webp', caption: 'Main Display B — Store Deployment' },
      { src: '/assets/migrated/2c0d7d854e2e08f3173b.webp', caption: 'Display Stand — Product Arrangement' },
      { src: '/assets/migrated/957f5f950e80084d7dcd.webp', caption: 'Trial Strategy — Customer Sampling' },
      { src: '/assets/migrated/f416365ba5a2b6502589.webp', caption: 'Promotion Image — Debut Campaign' },
      { src: '/assets/migrated/1ee4fc086fea0bb01400.webp', caption: 'Product Visual — Whitening Complete' },
      { src: '/assets/migrated/ff4bc7c2a56fdad8afc5.webp', caption: 'Market Analysis — Competitor Research' },
      { src: '/assets/migrated/b9ae5c173e8106077d42.webp', caption: 'Tools Catalog — Full Lineup' },
      { src: '/assets/migrated/d502b45dba3109f8df88.webp', caption: 'End Cap Display — Deployment Image A' },
      { src: '/assets/migrated/d1605862a474201be39b.webp', caption: 'Tools Catalog — Alternative View' },
      { src: '/assets/migrated/7baf5a49f984d5029359.webp', caption: 'Copy Development — Appeal Direction' },
      { src: '/assets/migrated/cfcf9839cfef9cf373f3.webp', caption: 'Premium Sample Box — Trial Kit Design' },
      { src: '/assets/migrated/d57017d9c48fd47a6af3.webp', caption: 'Copy Direction — Protect Whitening, Prevent Spots' },
      { src: '/assets/migrated/50333ecc5f72c6ba9c1b.webp', caption: 'Problem-Solving Summary — Store & Product Perspective' },
      { src: '/assets/migrated/b05d1e96667c923f7047.webp', caption: 'Positioning Map — Competitor Analysis' },
      { src: '/assets/migrated/cf1e1977e6510ec1fa70.webp', caption: 'Main Display A — In-Store Deployment Photos' },
      { src: '/assets/migrated/f67c1d58002517abc76f.webp', caption: 'Standard Sample Leaflet — Circular POP Designs' },
      { src: '/assets/migrated/144fff49a5a549e26f7c.webp', caption: 'Copy Direction — Spots, Never Wake Them Up' },
      { src: '/assets/migrated/acd6a2cb0ce72ab5ed16.webp', caption: 'Copy Direction — More and More Whitening' },
      { src: '/assets/migrated/8f9318a4745f35cbbbcc.webp', caption: 'Product Problem-Solving Chart — Detailed Analysis' },
      { src: '/assets/migrated/30139b602eb0981f545e.webp', caption: 'Retail Strategy Document — Planning Overview' },
      { src: '/assets/migrated/cc2ec806dc6b56a848c1.webp', caption: 'Product Visual & Store Display — Ad Creative + Shelf Deployment' },
      { src: '/assets/migrated/1b23018da23378cb3fe8.webp', caption: 'Various Tools — Chemical Panel + POP Sheet' },
      { src: '/assets/migrated/08e00d8defc836acd587.webp', caption: 'Premium Sample BOX B — Limited Premium Trial Kit' },
      { src: '/assets/migrated/c54a3b5cd838b8fbaa8a.webp', caption: 'Copy Direction — Whitening Complete. TRANSINO Born.' },
      { src: '/assets/migrated/154c2571bc10e96000eb.webp', caption: 'Store Environment — Drugstore Shelf Challenge Analysis' },
      { src: '/assets/migrated/78bb2a49761d4c65e0db.webp', caption: 'Main Board A — 450x300mm Medium Size Board' },
      { src: '/assets/migrated/32aa0ea788660e815395.webp', caption: 'Copy Direction — Spots, Never Wake Them Up.' },
      { src: '/assets/migrated/dbf199ae908af4816307.webp', caption: 'Main Display A — Tester-Integrated Store Display (W230)' },
      { src: '/assets/migrated/020d5d28b4e1a7e94ab8.webp', caption: 'Campaign Summary — Full Visual & Deployment Overview' },
    ],
  },
  androidRetailCase,
  kaoInfoCase,
  {
    id: 'saran-wrap',
    project: 'サランラップ カラフル3色フラワープレゼント',
    client: '旭化成ホームプロダクツ',
    year: '2015',
    category: 'Campaign / Retail / Promotion',
    role: 'Creative Direction / Campaign / Retail',
    issue: 'サランラップの販売促進キャンペーンとして、購買意欲を喚起し、店頭でのブランド存在感を高める必要があった。',
    challenge: 'ラップという日用品を、プレゼントキャンペーンを通じて選びたくなるブランドとして再認識させること。',
    insight: '「カラフル3色フラワー」というビジュアル訴求と、キャラクター（グリーンのクマ）を活用した親しみやすいキャンペーン展開が、日用品への感情的な接続を生む。',
    strategy: '「カラフル3色フラワープレゼント」を軸に、TVCM、チラシ、店頭什器、エンド陳列、TOPボードなど統一した販売促進展開を設計。',
    experience: 'TVCMでのキャラクター訴求、店頭でのエンド陳列什器展開、チラシ・POPによる訴求、販売接点での統一したブランド体験を構築。',
    output: 'TVCM / Key Visual / チラシ・POP / エンド陳列什器 / TOPボード / 販売促進展開',
    impact: 'キャンペーン期間中の購買意欲向上と、店頭でのブランド存在感強化を実現。',
    images: [
      { src: '/assets/migrated/8c624c81c83a3c8ec744.png', caption: 'Hero Visual — Saran Wrap Campaign' },
      { src: '/assets/migrated/98615e6b02687f1c81ff.webp', caption: 'KEY Visual — カラフル3色フラワープレゼント（クマキャラクター+3色サランラップ）' },
      { src: '/assets/migrated/316ebae738462baea71f.webp', caption: 'TV-CM — 4シーン展開（おにぎりラップ・走る・野餐・商品並び）' },
      { src: '/assets/migrated/2ba34a899fde6447d408.webp', caption: '販売促進総合展開 — チラシ+店頭什器+陳列+CMカット' },
      { src: '/assets/migrated/0ea741719937f858ecd4.webp', caption: 'エンド陳列什器 — 3D展開図' },
      { src: '/assets/migrated/3818ab963577e70e4e0c.webp', caption: 'TOPボード — W800×H300 横長メインビジュアル' },
    ],
  },
  {
    id: 'otona-furikake',
    project: 'Otona-no-Furikake 店頭施策のご提案',
    client: '永谷園',
    year: 'Archive',
    category: 'Category Reframing / Retail / Communication',
    role: 'Brand Strategy / Retail Communication / Store Promotion / Cross-MD',
    issue: 'ふりかけ類市場は09年後半から停滞感が市場を覆っている。子ども向けのイメージが根強く、大人向けの高付加価値を作る機会がある。GMS・SM共に展開がなされていないのが現状。競合はハウス食品やエスビー食品。',
    challenge: '「ごはんにかけるもの」という既成概念を打ち破り、あらゆる食のシーンで「魔法のシーズニング（調味料）」として活用できる新しいカテゴリー価値を店頭で実現すること。コーナー展開・GMS・SMでの新たな売場構成を勝ち取ること。',
    insight: '「おとなのふりかけ」は「ふりかけは子どものもの」という既成概念を打ち破ってきた商品。「スナック菓子もふりかけになる時代」・「ちょい足しクック」の流行を背景に、同機に「魔法のシーズニング」として拡張するタイミング。GMS・SMは新たな切り口の売り方（消費者への食の提案）を常に探している。',
    strategy: '「ふりかけBAR」コンセプトで展開。永谷園「おとなのふりかけ」を中心に、クロスMD展開用ツール（エンド回りフロア什器）、エンド展開ツール、店頭施策ツール一式12種で、単なる店頭だけでなくコーナー展開・エンド展開・島陳（アイランド）展開を可能にする展開設計。フリカケBOXキャラクター6種と2カテゴリー別スウィングPOPでカテゴリー訴求を実現。',
    experience: '展開想定: エンド回りフロア什器にレシピメニューを吹き下げて並設し、隣接布難商品からのクロス込みを評休。店頭什器・全12種ツール（600×900訴求ボード・300×900訴求ボード・天吊用タペストリー・レールシートPOP・仕切りPOP・席巧・A4三つ折リーフレット等）で店頭波及効果を極大化。',
    output: 'Brand Concept / Store Tool Design (12 types) / Cross-MD Strategy / End Display / Communication',
    impact: 'カテゴリーの再定義と新しい売場構成の勝ち取り。コーナー展開・GMS・SMでの新規棚獲得に貢献。「ふりかけ」の新しい使い方を「魔法のシーズニング」として店頭に確立。',
    images: [
      {
        src: '/assets/migrated/0e427e9a34da68f3877c.webp',
        caption: '永谷園「おとなのふりかけ」店頭施策のご提案 — 表紙（定番5・バラエティのスマートBOXパッケージ正面）',
      },
      {
        src: '/assets/migrated/969c94d2a7dfcba9cb64.webp',
        caption: '企画趣旨 — 競合となるのは、ハウス食品やエスビー食品だと、考えます。',
      },
      {
        src: '/assets/migrated/97e55c470b4185fd49a3.webp',
        caption: '市場の動向 — ふりかけカテゴリーの飽和状態。販売量・販売額曲線と「おかしなフリカケ」の大ヒット。さらに、スナック菓子もふりかけになる時代。',
      },
      {
        src: '/assets/migrated/d7877e29a5b036058953.webp',
        caption: 'クロスMD展開用ツール — エンド回りフロア什器「ふりかけBAR」・オリジナルレシピメニュー吹き下げ展示',
      },
      {
        src: '/assets/migrated/8f1de925302243a7a163.webp',
        caption: 'エンド展開ツール イメージ図 — 「おとなのふりかけ」が魔法のシーズニングに変化！エンド棚展開実波イメージ',
      },
      {
        src: '/assets/migrated/1fd77826cfcde6346480.webp',
        caption: '店頭施策ツール デザインコンセプト — キービジュアル定鮮板・300×900訴求ボード・フリカケBOXキャラクターサイン（6種）',
      },
      {
        src: '/assets/migrated/f4652fda6f962e24fbf2.webp',
        caption: '永谷園「おとなのふりかけ」店頭施策のご提案（別バージョン）— 永谷園ロゴ・定番5・SKUバラエティBOX正面',
      },
      {
        src: '/assets/migrated/7f6969ddef71d4bb38ce.webp',
        caption: '市場の動向＋売場の考察＋アレンジメニュー流行＋全体コンセプト（4分割）— 「ふりかけ」の、ひと味違う使い方で食を楽しみましょう！',
      },
      {
        src: '/assets/migrated/59580014d66ad5929ea3.webp',
        caption: '店頭施策ツール一式 — 全12種（キービジュアル600×900・300×900訴求ボード・天吊タペストリー・レールシートPOP・B4ポスター・スウィングPOP・A5ヘッダー・600×900腹巻POP等）',
      },
      {
        src: '/assets/migrated/b31e807801b53d42c5c4.webp',
        caption: '企画趣旨 — 「魔法のシーズニング（調味料）」概念提示。ふりかけはごはんにかけるだけではなく、あらゆる食のシーンで活用できる。',
      },
      {
        src: '/assets/migrated/fe44f3082aea758af398.webp',
        caption: '企画趣旨 — 「永谷園のふりかけ。競合は、丸美屋ではない。」新しいカテゴリー価値で差別化を図る戦略視点',
      },
      {
        src: '/assets/migrated/6d93dff6efe42d5fb09a.webp',
        caption: '店頭施策のご提案 — 永谷園「おとなのふりかけ」定番の5メニュー・バラエティの6メニューBOX展開',
      },
      {
        src: '/assets/migrated/24e1f5536d7de38c4050.webp',
        caption: '店頭施策ツール一式＋島陣アイランド展開＋クロスMD展開 — ふりかけBAR 全ツール総合展開イメージ',
      },
      {
        src: '/assets/migrated/57b82f691c1382df1212.webp',
        caption: '島陣（アイランド）展開 — ふりかけBAR 展開ツールイメージ図。おとなのふりかけ関連商品も一緒に販売',
      },
    ],
  },
  patexCase,
  {
    id: 'soflan',
    project: 'Soflan Aroma Rich',
    client: 'LION',
    year: '2011',
    category: 'Retail / Sensory Experience',
    role: 'Brand Experience / Retail / Communication',
    issue: '柔軟剤の香りの良さが、機能訴求に埋もれ、感覚的な魅力として伝わりにくかった。',
    challenge: '「香り」という感覚価値を、生活者に体験として届けること。',
    insight: '「香りとデオドラントのソフラン Aroma Rich Juliette」——幕が開いて奥から香りが広がり、新しい香りの世界へ招待するイメージ。下部は新商品のアロマオイルをイメージした水のしずくで演出。',
    strategy: '「艶めく夢のアロマ・デビュー」——商品を中央に配置して登場感を演出。立体ボードの3層構造（新商品＋幕＋背景）で、香りの豊かさを感覚体験として伝えるブランドコミュニケーションを設計。',
    experience: '店頭体験、立体ボードの香り演出、コミュニケーションを通じて感覚価値を伝達。',
    output: 'Brand Experience / Retail / 3D Display / Communication / Promotion',
    impact: '香りの感覚価値を体験として伝え、ブランド差別化を実現。',
    images: [
      { src: '/assets/migrated/821c68c890ded52f94c7.png', caption: 'Hero Visual — Soflan Aroma Rich Brand' },
      {
        src: '/assets/migrated/56e7b862afe36c59c930.webp',
        caption: 'コピー別案 — 「自由奔放なリッチアロマ。」「魅せる装いへのプロローグ ジュリエット誕生。」「心に薫る、昼と夜のアロマ。」「心に薫る、アロマの華やぎ。」「心うるおう、毎日のアロマ。」5方向コピー案',
      },
      {
        src: '/assets/migrated/e8dfe9d066c6f8080c36.webp',
        caption: 'トップボード A Plan（オモテ面）— 「艶めく夢のアロマ・デビュー」W880×H450 立体3層構造（新商品Juliette＋幕＋背景）',
      },
      {
        src: '/assets/migrated/66e5eba89295a7042864.webp',
        caption: 'トップボード A Plan（ウラ面）— 「ときめきを誘う豊かな香り」W880×H450 Juliette＋Scarlett＋Violetta 3商品並び',
      },
      {
        src: '/assets/migrated/bed9b02152b6ba2898d3.webp',
        caption: '店頭イメージ A Plan — トップボード・香り見本・スイングPOP・レールPOP（オモテ／ウラ面）・スイングPOP・香り見本 総合レイアウト',
      },
      {
        src: '/assets/migrated/00abc9b7e77f60926ab4.webp',
        caption: 'トップボード B Plan — 「アロマに引力」W880×H450 飾り枠＋シルクの布＋甘いピンクとブルー系カラー',
      },
      {
        src: '/assets/migrated/86a90e2c023d54e64df4.webp',
        caption: 'その他ツール — 立体レールPOP（蝶々POP差し込みスリット式）「ソフラン Aroma Rich」ブランドロゴ＋アラベスク装飾',
      },
      {
        src: '/assets/migrated/ea6930f49c9806b7da88.webp',
        caption: '売り場演出と商品特性から導き出すツール展開 ① — 課題「夏の販売時期に合わせた店頭演出」A認知・B拡大演出・C視覚的訴求 3フェーズ設計',
      },
      {
        src: '/assets/migrated/c493ebd3c63449fcf454.webp',
        caption: 'トップボード C Plan — 「A romantic night 深密なアロマに抱かれて」W880×H450 月夜の薄紫ベース＋Juliette新登場',
      },
      {
        src: '/assets/migrated/99d58cce9ec71b0532ea.webp',
        caption: '売り場の現状と課題 — A登場感訴求展開・Bシーズン訴求（春・夏）展開バージョン 競合分析・季節店頭実写',
      },
      {
        src: '/assets/migrated/69179b3fa14052ed40f2.webp',
        caption: '売り場の現状について — RENGO-SP 2011.03.04 タイトルページ',
      },
      {
        src: '/assets/migrated/cc7c876f6f07e6099fc4.webp',
        caption: '店頭イメージ B Plan — トップボード・レールPOP・スイングPOP・香り見本 総合レイアウト',
      },
      {
        src: '/assets/migrated/a17313b3c33f8862e870.webp',
        caption: '戦略資料 ② — 売り場演出と商品特性から導き出すツール展開へ「奥深い香りの効果感訴求を前面展開した新香調導入ツールのご提案！」',
      },
      {
        src: '/assets/migrated/132599f1bd8faede1f4b.webp',
        caption: 'その他ツール — 香り見本C（Juliette）立体POP「スイートフローラル調の甘くロマンティックな香り」',
      },
      {
        src: '/assets/migrated/037dc54208de01c389b2.webp',
        caption: '戦略資料 — A/B/C Plan総合「売り場演出と商品特性から導き出すツール展開へ ①」A Plan店頭レイアウト+C Plan店頭レイアウト+トップボードHero+3フェーズ設計',
      },
      {
        src: '/assets/migrated/2685dcfbecf59c97dd8d.webp',
        caption: '表紙 — 「ソフラン Aroma Rich Juliette 新香調導入ツールのご提案」レンゴー株式会社 2011.03.04',
      },
      {
        src: '/assets/migrated/65707f0255f6cbb8c1a3.webp',
        caption: 'デザインコンセプト タイトル — 「新香調導入ツール展開 デザインコンセプトについて」RENGO-SP 2011.03.04',
      },
      {
        src: '/assets/migrated/7236ab3563f8ebf3c9ee.webp',
        caption: '店頭イメージ C Plan — トップボード「A romantic night」・レールPOP・スイングPOP・香り見本 総合レイアウト',
      },
      {
        src: '/assets/migrated/c787051f69d98223c37e.webp',
        caption: 'デザインコンセプト — A/B/C Plan世界観・カラー・コピー解説「登場感/ブラックアロマ/ジュリエットをテーマに」',
      },
      {
        src: '/assets/migrated/7174b4714f2234c3ebb7.webp',
        caption: 'その他ツール — 香り見本A（現行品との比較写真）+ Juliette立体POP展開図「ボトル＋ポップアップ＋蝶々装飾」',
      },
      {
        src: '/assets/migrated/missing-transparent.gif',
        caption: '夏の販売時期に合わせた店頭演出の対応について — RENGO-SP 2011.03.04 タイトルページ',
      },
      {
        src: '/assets/migrated/missing-transparent.gif',
        caption: '夏の販売時期に合わせた店頭演出 — 問題点（視覚的乱雑・新商品引き立たない・訴求視認性低下）→ 解決策（ツール類に夏の色を訴求）',
      },
      {
        src: '/assets/migrated/missing-transparent.gif',
        caption: 'その他ツール — 香り見本B（Juliette）立体POP「スイートフローラル調の甘くロマンティックな香り」オモテ面／ウラ面',
      },
      {
        src: '/assets/migrated/missing-transparent.gif',
        caption: '売り場の現状と課題 — 他社製品に関しての訴求展開（花王・P&G・LION）競合店頭実写分析',
      },
    ],
  },
  {
    id: 'ziploc',
    project: 'Ziploc',
    client: '旭化成',
    year: '2015',
    category: 'Retail / Campaign / Experience',
    role: 'Brand Experience / Campaign / Retail',
    issue: '保存袋としての機能は認知されている一方、ブランドとしての新しい価値が乏しかった。',
    challenge: '日常の必需品を、暮らしの豊かさを支えるブランドとして再活性化すること。',
    insight: '「Open my Ziploc!」——保存袋としての機能の先にある、暮らしを整える新しい価値。新・パズル設計のコンテナーで、食品のロスを減らし、暮らしを豊かにする。',
    strategy: '「NEW! Ziploc コンテナー 新・パズル設計」——保存から暮らしの提案へ、カテゴリ価値を広げるリテールツールを設計。',
    experience: '店頭キャンペーン、暮らしの提案、コミュニケーションを通じてブランドを活性化。',
    output: 'Campaign / Retail / Experience / Communication',
    impact: 'ブランドの再活性化と、カテゴリ価値の拡張を実現。',
    images: [
      {
        src: '/assets/migrated/75aacd1398ac680e30bd.png',
        caption: 'Hero Visual — Ziploc Campaign',
      },
      {
        src: '/assets/migrated/dd2e0351e4511378dc44.webp',
        caption: 'Brand Tagline — Open my Ziploc!',
      },
      {
        src: '/assets/migrated/4f74aa4c5d0ec375f639.webp',
        caption: 'リテールPOP — コンテナー小型スイング W82×H83mm（3サイズ展開）',
      },
      {
        src: '/assets/migrated/e099e0a3493fdf7d32cb.webp',
        caption: 'Web Branding — Ziploc × LIFESTYLE ウェブページ＋ブランドサイト展開',
      },
      {
        src: '/assets/migrated/34a66ab116879e535301.webp',
        caption: 'Campaign Suite — Open my Ziploc! キャンペーン総合展開（A4ボード・POP・BMWプレゼント・吊り下げPOP）',
      },
      {
        src: '/assets/migrated/f5fc7972b78c6cc24695.webp',
        caption: 'KEY Visual — NEW! Ziploc コンテナー 新・パズル設計',
      },
      {
        src: '/assets/migrated/edafe78beef2bc10e97d.webp',
        caption: 'リテールPOP — コンテナー差込POP バラエティアソート W245×H260mm',
      },
      {
        src: '/assets/migrated/e5d18233a8763eb36ee0.webp',
        caption: 'TOP Board — トップボード H300×W800「タブがついて、あけやすい。」',
      },
      {
        src: '/assets/migrated/28ad844af7d6ba479c16.webp',
        caption: 'A4 Board — コンテナーA4ボード ベーシックアソート W297×H210mm',
      },
      {
        src: '/assets/migrated/9d74c1d4a2f8bc6c8f68.webp',
        caption: 'In-Store Photos — 店頭実写（陳列・キャンペーン展開・店頭什器）',
      },
      {
        src: '/assets/migrated/461b7dc719d83fd148dc.webp',
        caption: '店頭展開総合 — パズル設計Hero・店頭実写・POP複合',
      },
      {
        src: '/assets/migrated/983834cc0676f3e9c3bf.webp',
        caption: 'WEB LP — Ziploc スマートデザインPKG / ブランドサイト展開',
      },
      {
        src: '/assets/migrated/225c85854b0fc5c45ea7.webp',
        caption: 'Brand Tagline — 「Open my Ziploc!」+ 新・パズル設計 KEY Visual',
      },
      {
        src: '/assets/migrated/6c1741634e20e2a31aed.webp',
        caption: '4P流通パンフレット — Smart Ideas. Ziploc. リニューアルポイント・陳列例・モニター評価',
      },
      {
        src: '/assets/migrated/cfffb0bb4891c3335f5a.webp',
        caption: 'Web Branding — Ziploc × LIFESTYLE ウェブページ＋ブランドサイト展開',
      },
      {
        src: '/assets/migrated/59387081ab943137f083.webp',
        caption: '販促素材総合 — A4ボード・POP・パッケージ・リーフレット展開',
      },
      {
        src: '/assets/migrated/524e1e34adb9f7db2c50.webp',
        caption: 'A4ボード — コンテナー バラエティアソート W297×H210mm',
      },
      {
        src: '/assets/migrated/d1ff2b46cc3e43bf5b05.webp',
        caption: 'コンテナースイング — 万能ねぎ・ゆでたアスパラ W90×H58mm',
      },
      {
        src: '/assets/migrated/93924ec7310111fb1761.webp',
        caption: 'コンテナースイング — ブロッコリー・マリネ W90×H58mm',
      },
      {
        src: '/assets/migrated/dc427db47e043fa65041.webp',
        caption: 'コンテナースイング — ゆでたオクラ・ポテトサラダ W90×H58mm',
      },
      {
        src: '/assets/migrated/863f525c4505d80dac26.webp',
        caption: '棚置きディスプレイ Tool 解析図（B案）— 立面図・天面図 + 完成デザインイメージ',
      },
      {
        src: '/assets/migrated/5cbcaa1214057737d064.webp',
        caption: '店頭展開総合 — 新・パズル設計Hero・店頭実写・POP・キャンペーン・サランラップセット販売複合',
      },
      {
        src: '/assets/migrated/893f5c949f6a511027b7.webp',
        caption: 'KEY Visual（C案）— NEW! Ziploc コンテナー 新・パズル設計・キャッチ黄色+シャドー',
      },
      {
        src: '/assets/migrated/58e41fc13efec5e637eb.webp',
        caption: '差込POP — Ziplocコンテナー ベーシックアソート W245×H260mm',
      },
      {
        src: '/assets/migrated/21bad6c195b67f1816c9.webp',
        caption: 'Brand Tagline — 「Open my Ziploc!」+ 新・パズル設計 KEY Visual',
      },
      {
        src: '/assets/migrated/4d049e7d9b705319aa26.webp',
        caption: 'A4ボード — NEW! Ziploc タブがついて、あけやすい。H210×W297mm',
      },
    ],
  },
  {
    id: 'unite-card-tvcm',
    project: 'UNiTe Card TV-CM',
    client: '西鉄ストア / 西日本鉄道',
    year: '2022',
    category: 'TV-CM / Communication',
    role: 'Creative Direction / TV-CM / Communication / Storyboard',
    issue: '新ポイントカードの認知拡大と、地域生活者との関係性を映像で伝える必要があった。機能説明だけでは愛着が生まれない。',
    challenge: '15秒の短い尺で、「ポイントが貯まる」という機能的な話ではなく、「つながる」喜びを日常の瞬間で表現すること。',
    insight: '「貯まる」より「つながる」喜びを、日常の買い物や人との関係性の中で見せることこそが共感を生む。地域の日常がブランドの舞台になる。',
    strategy: '複数の15秒CMバリエーションで展開。「UNiTe People」「Everyday Feeling」「UPDANCE」「RUN MOVING SCENE」などのコンセプトで、地域の日常と人のつながりを軸にした映像を設計。8月・9月OA用の切替登録訴求も展開。',
    experience: 'TV-CMを通じたブランドへの感情的な接続構築。買い物の日常に溶け込む「つながり」の演出。',
    output: 'TV-CM複数本（15秒バリエーション）/ Storyboard / Communication Plan / Key Visual',
    impact: 'ブランド認知向上と、地域生活者との感情的なつながりの形成。切替登録・新規会員獲得に貢献。',
    images: [
      {
        src: '/assets/migrated/d111ded8045cee092a2e.webp',
        caption: '訴求ポイント分析・キーワード抽出 — ブランド戦略の基盤',
      },
      {
        src: '/assets/migrated/de6722be009c2aed511d.webp',
        caption: 'コミュニケーション設計 — ブランド方向性とメインビジュアル',
      },
      {
        src: '/assets/migrated/318b1aa20d0535dd1f29.webp',
        caption: 'TV-CM企画 Directionality — 媒体ミックス方向性とブランドアプローチ設計',
      },
      {
        src: '/assets/migrated/452a4aba7e7dc458eda9.webp',
        caption: 'TV-CM案 企画コンテ — 登場篇 / ブランド方向性（A/B/C方向）',
      },
      {
        src: '/assets/migrated/6aa03ea5ab6b46fb22f6.webp',
        caption: 'TV-CM イラスト方向性イメージ資料 & 視聴率データ — クリエイティブと効果予測',
      },
      {
        src: '/assets/migrated/928fae911b420077605f.webp',
        caption: 'TV-CM メディアミックス連動企画 — Directionality / Finally Again',
      },
      {
        src: '/assets/migrated/d1ee7a0a012d96816b3b.webp',
        caption: '媒体プラン — 短期集中案・長期案（GRP獲得計画）',
      },
      {
        src: '/assets/migrated/1c6492641feda85bca33.webp',
        caption: 'UNiTe Card TV-CM PLAN — Key Visual',
      },
      {
        src: '/assets/migrated/3683a4aa52ab61a4558d.webp',
        caption: 'UNiTe Card — Key Visual / カードデザイン',
      },
      {
        src: '/assets/migrated/137bba07c238ad210ac4.webp',
        caption: 'UNiTe Card キービジュアル — Rakuten Point × Edy 機能訴求「お買い物で楽天ポイントが使える！貯まる！」',
      },
      {
        src: '/assets/migrated/40267cb6963262a79d5e.webp',
        caption: 'TV-CM企画「UNiTe Card を 使いたくなる」/「UNiTe Card を 持ちたくなる！」',
      },
      {
        src: '/assets/migrated/0bbfd247503abd5dc76b.webp',
        caption: 'TV-CM ストーリーボード — ユナイトしないと篇 / UNiTe People篇',
      },
      {
        src: '/assets/migrated/5338b22c5f055c143abd.webp',
        caption: 'TV-CM ストーリーボード — 登場篇 / ユナイトしないと篇',
      },
      {
        src: '/assets/migrated/2a8ebda530c9212aa358.webp',
        caption: 'TV-CM 15秒 ストーリーボード — UP DANCE篇 / RUN MOVING SCENE篇',
      },
    ],
    videos: [
      {
        src: '/assets/migrated/23c83152dc7c1f27bf50.mp4',
        caption: 'UNiTe Card TV-CM 企画ムービー — 登場（オープニング）',
      },
      {
        src: '/assets/migrated/087cb03c5167fce60d19.mp4',
        caption: 'UNiTe Card TV-CM 企画ムービー — UNiTe',
      },
      {
        src: '/assets/migrated/1050c2347d58f1490bce.mp4',
        caption: 'UNiTe Card TV-CM 企画ムービー — 5色カラー展開',
      },
      {
        src: '/assets/migrated/c74c831489ff979b7fbc.mp4',
        caption: 'UNiTe Card TV-CM 企画ムービー — スタート',
      },
      {
        src: '/assets/migrated/440dc53cda4cf07c66f3.mp4',
        caption: 'UNiTe Card TV-CM 追加ムービー',
      },
    ],
  },

  {
    id: 'android-promo',
    project: 'Android Promotion',
    client: 'Android / Consumer Electronics',
    year: 'Archive',
    category: 'Promotion / Retail / Digital',
    role: 'Creative Direction / Promotion / Retail',
    issue: 'Androidの世界観を、店頭とデジタルで一貫して伝えるプロモーションが求められた。',
    challenge: '多様な端末・サービスを、ひとつの世界観として束ねて表現すること。',
    insight: 'Androidの多様性こそが強み。統一感より「選べる自由」を伝える。',
    strategy: '多様性を歓迎するブランドの姿勢を、店頭とデジタルで一貫して展開。',
    experience: '店頭プロモーション、デジタルコンテンツを通じて、ブランド世界観を伝達。',
    output: 'Promotion / Retail / Digital / Creative',
    impact: 'ブランド世界観の一貫した伝達と、店頭での差別化を実現。',
    images: [
      { src: '/assets/migrated/8245cf13f9ecb52977f5.jpg', caption: 'Hero Visual — Android Promotion Campaign' },
      {
        src: '/assets/migrated/881995c436a645bff078.webp',
        caption: 'Android Branding Plan 2016 — dentsu tempo 企画書表紙',
      },
      { src: '/assets/migrated/b9a161a784526e1d11f8.webp', caption: 'music? xperia! — やりたいことのそばにいる android（ローラ）' },
      {
        src: '/assets/migrated/bf5a6c1c7219df9753e1.webp',
        caption: 'photo? galaxy! — やりたいことのそばにいる android（有吉弘行）',
      },
      {
        src: '/assets/migrated/a055ab3e0c62b304b3c8.webp',
        caption: '4パネル統合広告 — music? xperia! / photo? galaxy! / voice? nexus!（ガチャピン・染谷将太風）',
      },
      {
        src: '/assets/migrated/b2a50e2a67a76f819076.webp',
        caption: 'PHOTO/TrueView2 + MUSIC/TVCM + MUSIC/TrueView1 企画書 — 4分割構成案',
      },
      { src: '/assets/migrated/ce302ad83f4d68def512.webp', caption: 'voice? nexus! — やりたいことのそばにいる android（ガチャピン）' },
      { src: '/assets/migrated/ebfa50ce88f6f1c3c3ec.webp', caption: 'voice? nexus! — やりたいことのそばにいる android（染谷将太風）' },
      { src: '/assets/migrated/9a576fe93c657b06d14f.webp', caption: 'photo? galaxy! — やりたいことのそばにいる android（有吉弘行風）' },
      { src: '/assets/migrated/af5f7cf322d93d655d91.webp', caption: '3パネル統合広告 — photo? music? voice? / galaxy! xperia! nexus!' },
      { src: '/assets/migrated/0376ada2767edac61cdd.webp', caption: 'Android Branding Plan 2016 — CM/TrueView/SNS キャスト・企画書' },
      {
        src: '/assets/migrated/33eca80a67cb8ba53efe.webp',
        caption: 'PHOTO/TVCM・TrueView・SNS 企画書 — 4分割構成案',
      },
      {
        src: '/assets/migrated/206e9051bd02d29053b3.webp',
        caption: 'MUSIC/SNS・TrueView・VOICE TVCM 企画書 — 4分割構成案',
      },
      {
        src: '/assets/migrated/c55912084dcae15d9995.webp',
        caption: '展開案 — Galaxy単体・3パネル統合・のぼりA/B',
      },
    ],
  },
  plusKeshiponCase,
  qSaiAojiruCase,
  originDesignThinkingCase,
];